import React from "react";

import core from "../../../vendors/core-api";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import TitleHelmet from "../../../partials/TitleHelmet";
import {
  ButtonGroup,
  Grid,
  Radio,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import {
  Badge,
  Button,
  Card,
  Col,
  Form,
  Row,
  Accordion,
  Modal,
  Tabs,
  Tab,
  InputGroup,
  Dropdown,
} from "react-bootstrap";
import DataTable from "react-data-table-component";

import { fetchData, getAvailabilityMessage } from "../../../helpers";
import {
  FormItem,
  HeaderTextWithActions,
  KTLink,
  Label,
} from "../../../components/Base";
import Breadcrumbs from "../../../components/Breadcrumbs";
import APIComponent from "../../../components/API";
import {
  isEmpty,
  isNull,
  debounce,
  sortBy,
  isEqual as lodashIsEqual,
} from "lodash";
import {
  DATE_OPTION_DISPLAY,
  DB_DATE_FORMAT,
  DB_HOURS_FORMAT,
  EVENT_NAME_LIMIT,
  RESERVATION_COLOR,
  TIME_OPTION_DISPLAY_FORMAT,
} from "../../../constants";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import PacmanLoading from "../../../components/widgets/PacmanLoading/PacmanLoading";
import ReactDatePicker from "react-datepicker";
import { MapComponent } from "../../../components/widgets/GMapsWidget";

import "react-datepicker/dist/react-datepicker.css";
import ProSourceForm from "../../../components/ProSourceForm";
import { toBase64 } from "../../../components/ImageUpload";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import moment from "moment/moment";
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import Dropzone from "react-dropzone";
import "react-accessible-accordion/dist/fancy-example.css";
import {
  eachDayOfInterval,
  nextMonday,
  format,
  getDay,
  startOfDay,
  isPast,
  isEqual,
  addDays,
} from "date-fns";
import interactionPlugin from "@fullcalendar/interaction";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import { KTUtil } from "../../../../_metronic/_assets/js/components/util";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import QRCode from "qrcode";

const MySwal = withReactContent(Swal);

export default function Page(props) {
  const { store_id = "", event_id = "" } = useParams();
  const { user } = useSelector((state) => state.auth);
  return (
    <MainComponent id={store_id} user={user} event_id={event_id} {...props} />
  );
}

const InviteLinkManagerModal = ({ show, onHide, store, event, api }) => {
  const [links, setLinks] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);
  const [newLinkTags, setNewLinkTags] = React.useState("");

  const fetchLinks = React.useCallback(async () => {
    setIsLoading(true);
    try {
      const { data } = await api.get(
        `/store/${store._id}/event/${event._id}/invite_link`,
      );

      setLinks(data || []);
    } catch (error) {
      console.error("Failed to fetch invite links", error);
      MySwal.fire("Error", "Failed to fetch invite links.", "error");
    } finally {
      setIsLoading(false);
    }
  }, [api, store._id, event._id]);

  React.useEffect(() => {
    if (show) {
      fetchLinks();
    }
  }, [show, fetchLinks]);

  const handleGenerate = async () => {
    const tags = newLinkTags
      .split(",")
      .map((tag) => tag.trim())
      .filter((tag) => tag);
    setIsLoading(true);
    try {
      const { data: newLink } = await api.post(
        {
          url: `/store/${store._id}/event/${event._id}/invite_link`,
          data: { tags },
        },
        {
          baseURL: api.getBaseURL(),
        },
      );

      setNewLinkTags("");
      await fetchLinks(); // Refresh the list
      MySwal.fire({
        title: "Link Generated!",
        html: `<p>Your new invite link is:</p><p><strong>${newLink.url}</strong></p>`,
        icon: "success",
        showCancelButton: true,
        confirmButtonText: '<i class="fas fa-copy"></i> Copy Link',
        cancelButtonText: "Close",
        confirmButtonColor: RESERVATION_COLOR,
      }).then((result) => {
        if (result.isConfirmed) {
          navigator.clipboard.writeText(newLink.url).then(() => {
            MySwal.fire({
              toast: true,
              position: "top-end",
              icon: "success",
              title: "Link copied to clipboard!",
              showConfirmButton: false,
              timer: 1500,
            });
          });
        }
      });
    } catch (error) {
      console.error("Failed to generate link", error);
      MySwal.fire("Error", "Failed to generate new link.", "error");
    } finally {
      setIsLoading(false);
    }
  };

  const handleStatusChange = async (link, disabled) => {
    try {
      await api.put({
        url: `/store/${store._id}/event/${event._id}/invite_link/${link.shortCode}`,
        data: { disabled },
      });

      setLinks(
        links.map((l) =>
          l.shortCode === link.shortCode ? { ...l, disabled } : l,
        ),
      );
      MySwal.fire({
        toast: true,
        position: "center",
        iconColor: RESERVATION_COLOR,
        icon: "success",
        title: `Link ${disabled ? "deleted" : "enabled"}`,
        showConfirmButton: false,
        timer: 1500,
      });
    } catch (error) {
      console.error("Failed to update link status", error);
      MySwal.fire("Error", "Failed to update link status.", "error");
    }
  };

  const handleCopy = (url) => {
    navigator.clipboard.writeText(url).then(() => {
      MySwal.fire({
        toast: true,
        iconColor: RESERVATION_COLOR,
        position: "center",
        icon: "success",
        title: "Link copied to clipboard!",
        showConfirmButton: false,
        timer: 1500,
      });
    });
  };

  const handleDelete = (link) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "This will delete the link!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      confirmButtonColor: RESERVATION_COLOR,
      cancelButtonColor: "#d33",
    }).then((result) => {
      if (result.isConfirmed) {
        handleStatusChange(link, true);
      }
    });
  };

  const handleGenerateQR = async (link) => {
    try {
      const url = await QRCode.toDataURL(link.redirectUrl, { width: 300 });
      const a = document.createElement("a");
      a.href = url;
      a.download = `qr-code-${link.shortCode}.png`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (err) {
      console.error("Failed to generate QR code", err);
      MySwal.fire("Error", "Failed to generate QR code.", "error");
    }
  };

  const columns = [
    {
      name: "Link Code",
      cell: (row) => (
        <div className="d-flex align-items-center">
          <Button variant="info" onClick={() => handleCopy(row.redirectUrl)}>
            <i className="mr-2 fas fa-copy"></i>
            <span>{row.shortCode}</span>
          </Button>
        </div>
      ),
    },
    {
      name: "Tags",
      selector: (row) => row.tags,
      cell: (row) => (
        <div>
          {row.tags && row.tags.length > 0 ? (
            row.tags.map((tag, index) => (
              <Badge
                key={index}
                pill
                className="mr-1 text-white"
                style={{ backgroundColor: RESERVATION_COLOR }}
              >
                {tag}
              </Badge>
            ))
          ) : (
            <span className="text-muted">No tags</span>
          )}
        </div>
      ),
    },

    {
      name: "Download QR Code",
      center: true,
      cell: (row) => (
        <Button
          variant="outline-info"
          className="ml-2"
          onClick={() => handleGenerateQR(row)}
        >
          <i className="fas fa-qrcode"></i>
        </Button>
      ),
    },
    {
      name: "Actions",
      center: true,
      cell: (row) => (
        <Button
          variant="light-danger"
          className="btn-icon btn-sm"
          onClick={() => handleDelete(row)}
        >
          <i className="fas fa-trash"></i>
        </Button>
      ),
    },
  ];

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Manage Invite Links</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-muted">
          These invite links are publicly available—share or post the link on
          Instagram, Facebook, or anywhere, or generate a QR code for easy
          access. Anyone with the link can use it.
        </p>
        <div className="mb-4 p-3 border rounded">
          <h5 className="font-weight-bolder">Generate New Link</h5>
          <Form.Group>
            <Form.Label>Tags (comma-separated)</Form.Label>
            <InputGroup className="mb-3">
              <Form.Control
                type="text"
                variant="info"
                placeholder="e.g. marketing, VIP, partner-A"
                value={newLinkTags}
                onChange={(e) => setNewLinkTags(e.target.value)}
                aria-label="Tags for new invite link"
                className=""
              />
              <Button
                variant="info"
                className="ml-2"
                onClick={handleGenerate}
                disabled={isLoading || !newLinkTags.trim()}
                style={{
                  backgroundColor: RESERVATION_COLOR,
                  borderColor: RESERVATION_COLOR,
                }}
              >
                {isLoading ? "Generating..." : "Generate Link"}
              </Button>
            </InputGroup>
          </Form.Group>
        </div>
        <DataTable
          columns={columns}
          data={links.filter((l) => !l.disabled)}
          title="Invite Links"
          progressPending={isLoading}
          progressComponent={<PacmanLoading />}
          noDataComponent={
            <div className="p-4 text-center text-muted">
              No invite links generated yet.
            </div>
          }
          pagination
          persistTableHead
        />
      </Modal.Body>
    </Modal>
  );
};

class MainComponent extends APIComponent {
  constructor(props) {
    super(props);

    this.state = {
      showSplashScreen: false,
      redirectTo: "",
      mountForm: true,
      groupName: "",
      store: {},
      isSubmitting: false,
      isEdit: !isEmpty(props.event_id),
      isMapLoading: true,
      event: {},
      title: `${!isEmpty(props.event_id) ? "Update" : "Create New"} Event`,
    };
    this.api = core("pu").get();
    this.fileapi = core("puf").get();
    this.data_url = `/store/${props.id}/event${
      !isEmpty(props.event_id) ? `/${props.event_id}` : ""
    }`;
  }

  async componentDidMount() {
    this._isMounted = true;

    await this.getData();
  }

  getData = async () => {
    this._isMounted && this.setState({ data_status: "fetching" });
    this.api &&
      this.api
        .get(this.data_url)
        .then(({ data }) => {
          this._isMounted &&
            this.setState({
              event: isEmpty(data.event) ? null : data.event,
              store: data.store,
              data_status: "fetched",
              groupName: data.store.brand.client.name,
            });
        })
        .catch((err) => {
          this._isMounted && this.setState({ error: err, showSwalError: true });
          if (err.hasOwnProperty("response")) {
            const { data = {} } = err.response,
              { error_message = {}, error = "" } = data;
            if (!isEmpty(error_message)) {
              MySwal.fire({
                icon: "error",
                title: "Ooops!",
                text: error_message,
                confirmButtonColor: RESERVATION_COLOR,
                confirmButtonText: "OK",
                showCancelButton: false,
              });
              if (!isEmpty(error)) {
                if (error === "EventNotFund") {
                  this.props.history.push(`/stores/${this.props.id}/events`);
                }
              }
            } else {
              this.handleOnDataFetchError();
            }
          }
          this.handleOnDataFetchError();
        });
  };

  render() {
    const {
      groupName,
      data_status = "fetched",
      store,
      isEdit,
      title,
    } = this.state;

    return (
      <>
        {data_status === "fetching" && (
          <div className="d-flex justify-content-center align-items-center h-100">
            <PacmanLoading />
          </div>
        )}
        {data_status === "fetched" && (
          <>
            {" "}
            <TitleHelmet title={title} />
            <HeaderTextWithActions
              breadcrumbs={
                <Breadcrumbs>
                  <Breadcrumbs.Item text={groupName} link={`/stores`} />
                  <Breadcrumbs.Item
                    text="Events"
                    link={`/stores/${store._id}/events`}
                  />
                  <Breadcrumbs.Item
                    text={`${isEdit ? "Edit" : "Add"} Event`}
                    active={"true"}
                  />
                </Breadcrumbs>
              }
            />
            <CreateEventForm
              event={this.state.event}
              isEdit={isEdit}
              api={this.api}
              state={this.state}
              getData={this.getData}
              {...this.props}
            />
          </>
        )}
      </>
    );
  }
}

class CreateEventForm extends ProSourceForm {
  constructor(props) {
    super(props);
    const { event = {} } = props;
    const next_monday = startOfDay(nextMonday(new Date()));
    this.calendarRef = React.createRef();
    this.guestCalendarRef = React.createRef();
    this.formRef = React.createRef();

    this.state = {
      ...props.state,
      values: {
        mapPosition: {
          lat: "",
          lng: "",
        },
        currentPosition: {
          lat: "",
          lng: "",
        },
        event_location: { lat: "", lng: "" },
        event_name: "",
        zoom_value: 18,
        start_date: isEmpty(event)
          ? next_monday
          : moment(event["start_date"]).local(),
        end_date: isEmpty(event)
          ? next_monday
          : moment(event["end_date"]).local(),
        capacity: 1,
        price: 100,
        active: false,
        delivery_address: !isEmpty(event) ? event.location_address : "",
        delivery_city: "",
        status: "private",
        dress_code: !isEmpty(event) ? event.dress_code : "",
        cancellation_policy: !isEmpty(event) ? event.cancellation_policy : "",
        blockout_dates: !isEmpty(event) ? event.blockout_dates || [] : [],
        tickets: !isEmpty(event)
          ? event.tickets.map((ticket) => ({
              ...ticket,
              name: ticket.item.name,
              description: ticket.item.description,
              time_slots: sortBy(
                this.formatTimeSlots(ticket, event.time_slots),
                "_id",
              ),
              quantity: ticket.capacity,
              price: ticket.item.price,
              isValid: true,
              isTouched: false,
              isAdded: ticket.item.name.trim() === "",
            }))
          : [],
        time_slots: isEmpty(event)
          ? [
              {
                start_time: new Date(
                  new Date().getFullYear(),
                  new Date().getMonth(),
                  new Date().getDate(),
                  16,
                ),
                end_time: new Date(
                  new Date().getFullYear(),
                  new Date().getMonth(),
                  new Date().getDate(),
                  17,
                ),
                isStartValid: true,
                isEndValid: true,
              },
            ]
          : event.time_slots.map((slot) => {
              return {
                ...slot,
                start_time: new Date(slot.start_time),
                end_time: new Date(slot.end_time),
                isStartValid: true,
                isEndValid: true,
              };
            }),
        available_days: !isEmpty(event)
          ? event["available_days"]
          : [0, 1, 2, 3, 4, 5, 6],
        ordering_cutoff: !isEmpty(event) ? event["ordering_cutoff"] : 0,
        guestList: Array(8)
          .fill()
          .map(() => ({
            firstName: "",
            lastName: "",
            email: "",
            contact: "",
            ticketType: "",
            quantity: "",
            rsvp_deadline: "",
            isEditing: false,
          })),
        tierGroup: !isEmpty(event)
          ? this.formatTierGroup(event)
          : [
              {
                name: "",
                price: "",
                description: "",
                capacity: "",
                time_slots: [0],
                isEdit: true,
              },
            ],
      },
      eventFrequency:
        isEmpty(event) || event.available_days.length === 7
          ? "daily"
          : "selectedDays",
      isOneDayEvent: !isEmpty(event)
        ? moment(event["start_date"]).isSame(event["end_date"], "day")
        : false,
      selectedSlot: "",
      selectedTimeSlot: "",
      guestListActiveDate: "",
      slotTickets: [],
      dressCodeModal: false,
      blockoutDatesModal: false,
      guestListModal: false,
      errors: [],
      touched: {},
      isSubmitting: false,
      isVerifying: false,
      isNameValid: true,
      isEventTimeValid: true,
      isEventDateValid: true,
      isDescriptionValid: false,
      isEventNameCountValid: true,
      isNotAvailableOnAnyDay: false,
      showAvailabilityOption: false,
      isSavingForLater: false,
      isSendingInvites: false,
      activeKeys: ["0", "1", "2", "3", "4", "5", "guestCalendar"], // track open accordion keys here
      showRsvpModal: false,
      rsvpDeadline: null,
      activeReInvite: null,
      _rsvpPromiseResolver: null,
      guestListActiveTab: "all",
      initialValues: null,
      showInviteLinkModal: false,
      loadingSlotId: null,
    };
    this.fileapi = core("puf").get();
    this.api = props.api;
    this.buttonRefs = [];
    this.validate = {
      required: [
        "event_location",
        "start_date",
        "start_time",
        "end_date",
        "end_time",
        "description",
        "image_url",
        "price",
        "event_name",
      ],
    };
    this.onVerifyEventName = this.onVerifyEventName.bind(this);
    this.handlePhotoUpload = this.handlePhotoUpload.bind(this);
    this.populateValues = this.populateValues.bind(this);
    this.onCreateEvent = this.onCreateEvent.bind(this);
    this.onUpdateEvent = this.onUpdateEvent.bind(this);
    this.handleEventError = this.handleEventError.bind(this);
    this.formatEventObject = this.formatEventObject.bind(this);
    this.onStatusChange = this.onStatusChange.bind(this);
    this.onDressCodeChange = this.onDressCodeChange.bind(this);
    this.bulkCancelInvites = this.bulkCancelInvites.bind(this);
    this.changeModalVisible = this.changeModalVisible.bind(this);
    this.handleGuestChange = this.handleGuestChange.bind(this);
    this.selectAllow = this.selectAllow.bind(this);
    this.dateClick = this.dateClick.bind(this);
    this.dayCellClassNames = this.dayCellClassNames.bind(this);
    this.handleDownloadCSVTemplate = this.handleDownloadCSVTemplate.bind(this);
    this.handleDownloadAttendingCSV =
      this.handleDownloadAttendingCSV.bind(this);
    this.handleAffectedInvites = this.handleAffectedInvites.bind(this);
    this.handleDownloadPDF = this.handleDownloadPDF.bind(this);
  }

  findTicketsByTimeSlot = (timeSlotId) => {
    const { tickets } = this.state.values;
    if (!tickets || !timeSlotId) {
      return [];
    }
    return tickets.filter((ticket) =>
      ticket.time_slots.some((slot) => slot._id === timeSlotId),
    );
  };

  handleAffectedInvites = async (newSchedule, isFromRemoveTimeSlot = false) => {
    const { event, store } = this.state;
    const params = new URLSearchParams({
      event_id: event._id,
      check_affected: true,
      new_start_date: moment(newSchedule.start_date).format("YYYY-MM-DD"),
      new_end_date: moment(newSchedule.end_date).format("YYYY-MM-DD"),
      new_available_days: newSchedule.available_days.join(","),
      new_time_slots: JSON.stringify(
        newSchedule.time_slots.map((ts) => ({
          start_time: ts.start_time,
          end_time: ts.end_time,
        })),
      ),
    });
    const { data: invites } = await this.api.get(
      `/store/${store._id}/complimentary_tickets?${params.toString()}`,
    );

    if (invites && invites.length > 0) {
      const InvitesAccordion = ({ invites }) => {
        const [isOpen, setIsOpen] = React.useState(false);

        return (
          <div className="mb-3">
            <a
              href="#!"
              onClick={(e) => {
                e.preventDefault();
                setIsOpen(!isOpen);
              }}
              style={{ color: RESERVATION_COLOR, textDecoration: "none" }}
            >
              <i
                className={`fas fa-chevron-${isOpen ? "up" : "down"} mr-2`}
              ></i>
              {invites.length} affected guest(s)
            </a>
            {isOpen && (
              <div
                style={{
                  maxHeight: "200px",
                  overflowY: "auto",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                  marginTop: "0.5rem",
                }}
              >
                <table className="table table-md table-bordered">
                  <thead>
                    <tr>
                      <th>Guest</th>
                      <th>Date</th>
                      <th>Time</th>
                      <th>Type</th>
                    </tr>
                  </thead>
                  <tbody>
                    {invites.map((invite) => (
                      <tr key={invite._id}>
                        <td>
                          {`${invite.guest_customer.first_name || ""} ${
                            invite.guest_customer.last_name || ""
                          }`.trim()}
                        </td>
                        <td>
                          {moment(invite.order_date, DB_DATE_FORMAT).format(
                            DATE_OPTION_DISPLAY,
                          )}
                        </td>
                        <td>
                          {moment(invite.order_time, DB_HOURS_FORMAT).format(
                            TIME_OPTION_DISPLAY_FORMAT,
                          )}
                        </td>
                        <td className="text-center">
                          {invite.rsvp_deadline ? (
                            <i
                              className="fas fa-envelope text-info"
                              title="Invite"
                            />
                          ) : (
                            <i
                              className="fas fa-store-alt text-success"
                              title="Booked from Marketplace"
                            />
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        );
      };
      const result = await MySwal.fire({
        icon: "warning",
        title: "Schedule Change Affects Invitations",
        html: (
          <div style={{ textAlign: "left" }}>
            <p>
              Changing the event schedule will affect {invites.length} existing
              guest invitation(s). Please choose an action for these invites.
            </p>
            <InvitesAccordion invites={invites} />
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="inviteAction"
                id="rescheduleInvites"
                value="reschedule"
                defaultChecked={!isFromRemoveTimeSlot}
                disabled={isFromRemoveTimeSlot}
                style={{ accentColor: RESERVATION_COLOR }}
              />
              <label className="form-check-label" htmlFor="rescheduleInvites">
                Notify and reschedule guest invites and tickets
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="inviteAction"
                id="cancelInvites"
                value="cancel"
                defaultChecked={isFromRemoveTimeSlot}
                style={{ accentColor: RESERVATION_COLOR }}
              />
              <label className="form-check-label" htmlFor="cancelInvites">
                Cancel & Refund all affected invites. Guests will be notified
              </label>
            </div>
          </div>
        ),
        showCancelButton: true,
        confirmButtonText: "Confirm Changes",
        cancelButtonText: "Cancel",
        width: "800px",
        confirmButtonColor: RESERVATION_COLOR,
        preConfirm: () => {
          const selectedAction = document.querySelector(
            'input[name="inviteAction"]:checked',
          );
          return selectedAction ? selectedAction.value : null;
        },
      });

      if (result.isConfirmed) {
        const action = result.value;
        if (action === "cancel") {
          await this.bulkCancelInvites(invites);
          MySwal.fire(
            "Cancelled",
            "Affected invitations have been cancelled.",
            "success",
          );
        } else if (action === "reschedule") {
          // For now, this will also just cancel the invites.
          // A specific "reschedule" notification might need a new API endpoint.
          MySwal.fire(
            "Guests Notified",
            "Affected invitations have been cancelled and guests can be notified to reschedule.",
            "success",
          );
        }
        return true; // Proceed with action
      } else {
        return false; // Abort action
      }
    }
    return true; // No invites affected, proceed.
  };

  componentDidMount() {
    if (this.props.isEdit) {
      this.populateValues();
    } else {
      this.setState({
        initialValues: JSON.parse(JSON.stringify(this.state.values)),
      });
    }
  }

  handleDownloadCSVTemplate = () => {
    const { slotTickets } = this.state;
    const headers = [
      "firstName",
      "lastName",
      "email",
      "contact",
      "ticketType",
      "quantity",
    ];
    let csvContent = "";
    if (slotTickets && slotTickets.length > 0) {
      const ticketTypeNames = slotTickets
        .map((ticket) => ticket.item.name)
        .join(" | ");
      csvContent += `# For the 'ticketType' column, please use one of the following: ${ticketTypeNames}\n`;
    }
    csvContent += headers.join(",") + "\n";
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", "guest_list_template.csv");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  handleDownloadAttendingCSV = () => {
    const { guestList } = this.state.values;
    const { slotTickets, event } = this.state;

    const attendingGuests = guestList.filter(
      (guest) => guest.invite_status === "confirmed",
    );

    if (attendingGuests.length === 0) {
      MySwal.fire({
        icon: "info",
        title: "No Attending Guests",
        text: "There are no guests marked as attending to download.",
        confirmButtonColor: RESERVATION_COLOR,
      });
      return;
    }

    const headers = [
      "firstName",
      "lastName",
      "email",
      "contact",
      "ticketType",
      "quantity",
    ];

    const csvRows = [headers.join(",")];

    attendingGuests.forEach((guest) => {
      const ticket = slotTickets.find((t) => t.item._id === guest.ticketType);
      const ticketTypeName = ticket ? ticket.item.name : "N/A";
      const row = [
        `"${guest.firstName || ""}"`,
        `"${guest.lastName || ""}"`,
        `"${guest.email || ""}"`,
        `"${guest.contact || ""}"`,
        `"${ticketTypeName}"`,
        `"${guest.quantity || ""}"`,
      ].join(",");
      csvRows.push(row);
    });

    const csvContent = csvRows.join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      const eventName = event.name.replace(/ /g, "_");
      link.setAttribute("href", url);
      link.setAttribute("download", `${eventName}_attending_guests.csv`);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  handleDownloadPDF = () => {
    const { event_name, guestList } = this.state.values;
    const { guestListActiveDate, selectedTimeSlot, slotTickets, event } =
      this.state;

    const attendingGuests = guestList.filter(
      (guest) => guest.invite_status === "confirmed",
    );

    if (attendingGuests.length === 0) {
      MySwal.fire({
        icon: "info",
        title: "No Attending Guests",
        text: "There are no guests marked as attending to download.",
        confirmButtonColor: RESERVATION_COLOR,
      });
      return;
    }

    const doc = new jsPDF();

    doc.setFontSize(22);
    doc.text(event_name, 14, 20);

    doc.setFontSize(12);
    const dateStr = moment(guestListActiveDate).format("MMMM DD, YYYY");
    doc.text(`Date: ${dateStr}`, 14, 30);
    doc.text(`Time: ${selectedTimeSlot}`, 14, 38);

    const tableColumn = [
      "First Name",
      "Last Name",
      "Email",
      "Contact",
      "Ticket Type",
      "Quantity",
    ];
    const tableRows = [];

    attendingGuests.forEach((guest) => {
      const ticket = slotTickets.find((t) => t.item._id === guest.ticketType);
      const ticketTypeName = ticket ? ticket.item.name : "N/A";
      const guestData = [
        guest.firstName || "",
        guest.lastName || "",
        guest.email || "",
        guest.contact || "",
        ticketTypeName,
        guest.quantity || "",
      ];
      tableRows.push(guestData);
    });

    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 50,
      theme: "grid",
      headStyles: { fillColor: [137, 80, 252] },
    });

    const eventName = event.name.replace(/ /g, "_");
    doc.save(`${eventName}_attending_guests.pdf`);
  };

  handleUploadCSV = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (event) => {
      const text = event.target.result;
      // Simple CSV parsing (no quoted fields)
      const rows = text
        .split("\n")
        .map((row) => row.trim()) // trim whitespace
        .filter((row) => row && !row.startsWith("#"));

      // Check for header and slice it off
      const guestRows =
        rows.length > 0 && rows[0].toLowerCase().includes("firstname")
          ? rows.slice(1)
          : rows;
      const guests = guestRows.map((row) => {
        const [firstName, lastName, email, contact, ticketTypeName, quantity] =
          row.split(",");

        const ticket = this.state.slotTickets.find(
          (t) =>
            t.item.name.trim().toLowerCase() ===
            ticketTypeName?.trim().toLowerCase(),
        );
        const ticketTypeId = ticket ? ticket.item._id : "";
        return {
          firstName: firstName?.trim() || "",
          lastName: lastName?.trim() || "",
          email: email?.trim() || "",
          contact: contact?.trim() || "",
          ticketType: ticketTypeId,
          quantity: quantity?.trim() || "",
        };
      });
      this.setState((prev) => {
        const existingGuestList = prev.values.guestList;

        // Find the index of the last row with any data.

        const firstEmptyIndex = existingGuestList.findIndex(
          (guest) =>
            !guest.firstName &&
            !guest.lastName &&
            !guest.email &&
            !guest.contact &&
            !guest.quantity,
        );

        // Take the slice of the guest list up to and including the last filled row.
        const baseGuestList = existingGuestList.slice(0, firstEmptyIndex);

        // Append the new guests from the CSV.
        const combinedGuestList = [...baseGuestList, ...guests];
        const { slotTickets } = this.state;

        // Ensure there are at least 10 rows for display purposes, consistent with updateGuestList
        if (combinedGuestList.length < 10) {
          const emptyRowsToAdd = 10 - combinedGuestList.length;
          for (let i = 0; i < emptyRowsToAdd; i++) {
            combinedGuestList.push({
              firstName: "",
              lastName: "",
              email: "",
              contact: "",
              ticketType:
                slotTickets.length === 1 ? slotTickets[0].item._id : "",
              quantity: "",
              isEditing: false,
            });
          }
        }

        return {
          values: {
            ...prev.values,
            guestList: combinedGuestList,
          },
        };
      });
    };
    reader.readAsText(file);
  };

  changeModalVisible = (code, visible) => {
    const { values } = this.state;
    values[code] = visible;
    if (code === "blockoutDatesModal" || code === "guestListModal") {
      if (visible) {
        setTimeout(() => {
          if (this.calendarRef.current) {
            this.calendarRef.current.getApi().updateSize();
          }
          if (this.guestCalendarRef.current) {
            this.guestCalendarRef.current.getApi().updateSize();
          }
        }, 100);
      }
    }
    this.setState({ values });
  };

  populateValues = async () => {
    const { event, store, values } = this.state;
    if (!isEmpty(event)) {
      const result = await fetchData(
        "get",
        `/store/${store._id}/event/${event._id}/promote`,
      );

      let promotion = [];

      if (result && result.status === 200) {
        promotion = result.data?.promotions || [];
      }

      const {
        name,
        location_address,
        location,
        start_date,
        end_date,
        image_url,
        status,
        description,
        capacity,
      } = event;

      values.event_name = name;
      values.event_location = location_address;
      values.start_date = start_date;
      values.end_date = end_date;
      values.description = description;
      values.image_url = image_url;
      values.capacity = capacity;
      values.status = status;
      values.promote = Boolean(promotion.length);
      values.delivery_address = location_address;
      values.mapPosition = {
        lat: "",
        lng: "",
      };
      values.markerPosition = {
        lat: location.coordinates[1],
        lng: location.coordinates[0],
      };
      values.currentPosition = {
        lat: location.coordinates[1],
        lng: location.coordinates[0],
      };
      values.zoom_value = 18;
      values.delivery_city = "";

      this.setState(
        { values, isNameValid: true, isDescriptionValid: true },
        () => {
          this.setState({ initialValues: JSON.parse(JSON.stringify(values)) });
        },
      );
    }
  };
  getComplimentaryTickets = async (timeslot) => {
    const { store, guestListActiveDate, event } = this.state;

    try {
      return this.api
        .get(
          `/store/${store._id}/complimentary_tickets?event_date=${moment(
            guestListActiveDate,
          ).format(DB_DATE_FORMAT)}&timeslot=${moment(timeslot).format(
            DB_HOURS_FORMAT,
          )}&event_id=${event._id}`,
          {
            headers: {
              Authorization: `Basic ${window.btoa(store.brand.brand_url)}`,
            },
            baseURL: this.api.getBaseURL(),
          },
        )
        .then(({ data }) => {
          if (data) {
            return data.map((order) => {
              const {
                guest_customer: {
                  first_name,
                  last_name,
                  email,
                  contact_number,
                },
                order_details,
                invite_status,
                rsvp_deadline,
                invite_link,
              } = order;
              const [details] = order_details;
              if (!details) return null;
              let ticketType = "";
              if (details?.item) {
                ticketType = details.item._id;
              }

              return {
                _id: order._id,
                firstName: first_name,
                lastName: last_name,
                email,
                contact: contact_number,
                ticketType,
                quantity: details.qty,
                invite_status,
                rsvp_deadline,
                invite_link,
                isEditing: false,
                partner_identifier: order.partner_identifier || "",
              };
            });
          }
        });
    } catch (err) {
      this.handleEventError(err);
    }
  };

  openRsvpModal = () => {
    const { guestListActiveDate } = this.state;
    const defaultRsvpDate = moment(guestListActiveDate).toDate();

    this.setState({
      showRsvpModal: true,
      rsvpDeadline: defaultRsvpDate,
    });
  };

  handleRsvpConfirm = () => {
    this.processComplimentaryTickets({ withEmail: true });
  };

  handleRsvpCancel = () => {
    this.setState({
      showRsvpModal: false,
      rsvpDeadline: null,
    });
  };

  updateInvite = async (guestId, action) => {
    this.setState({ isSubmitting: true });

    try {
      const response = await this.api.put({
        url: `/orders/event/invites/${guestId}`,
        data: { action },
      });

      if (!response) return;

      const order_id = response?.data?.order_id;
      const new_status = response?.data?.new_status;
      MySwal.fire({
        icon: "success",
        title: "Success!",
        text:
          action === "cancel" ? "Invitation cancelled." : "Invitation updated.",
        confirmButtonColor: RESERVATION_COLOR,
      });

      if (action === "cancel" && order_id) {
        this.setState((prevState) => ({
          values: {
            ...prevState.values,
            guestList: prevState.values.guestList.filter(
              (guest) => guest._id?.toString() !== order_id?.toString(),
            ),
          },
        }));
      } else if (action === "reject" && order_id) {
        // Update the guest's invite_status
        this.setState((prevState) => ({
          values: {
            ...prevState.values,
            guestList: prevState.values.guestList.map((guest) =>
              guest._id?.toString() === order_id?.toString()
                ? { ...guest, invite_status: new_status || "rejected" }
                : guest,
            ),
          },
        }));
      }
    } catch (err) {
      this.handleEventError(err);
    } finally {
      this.setState({ isSubmitting: false });
    }
  };

  processComplimentaryTickets = async ({ withEmail = false }) => {
    const loadingKey = withEmail ? "isSendingInvites" : "isSavingForLater";
    this.setState({ [loadingKey]: true });
    const {
      store,
      guestListActiveDate,
      selectedSlot,
      values: { guestList },
      slotTickets,
      rsvpDeadline,
      activeReInvite,
    } = this.state;
    const reInvite = !isNull(activeReInvite);
    const filteredGuestList = reInvite
      ? guestList.filter((guest) => guest._id === activeReInvite)
      : guestList.filter(
          (guest) =>
            guest.firstName.trim() ||
            guest.lastName.trim() ||
            guest.email.trim() ||
            guest.contact.trim() ||
            guest.quantity.trim(),
        );

    const overLimitGuests = filteredGuestList.filter(
      (guest) => Number(guest.quantity) > 10,
    );
    if (overLimitGuests.length > 0) {
      MySwal.fire({
        icon: "error",
        title: "Quantity Limit Exceeded",
        text: "Each guest's quantity must not exceed 10.",
        confirmButtonColor: RESERVATION_COLOR,
      });
      this.setState({ [loadingKey]: false });
      return;
    }

    const guestsWithoutQuantity = filteredGuestList.filter(
      (guest) => !guest.quantity || parseInt(guest.quantity, 10) < 1,
    );

    if (guestsWithoutQuantity.length > 0) {
      MySwal.fire({
        icon: "error",
        title: "Missing or Invalid Quantity",
        text: `The following guest(s) are missing a valid quantity: ${guestsWithoutQuantity
          .map((g) => g.email || `${g.firstName} ${g.lastName}`.trim())
          .join(", ")}`,
        confirmButtonColor: RESERVATION_COLOR,
      });
      this.setState({ [loadingKey]: false });
      return;
    }

    // Check for duplicate emails
    const emails = filteredGuestList
      .map((guest) => guest.email.trim().toLowerCase())
      .filter((email) => email);
    const duplicates = emails.filter(
      (email, idx) => emails.indexOf(email) !== idx,
    );
    if (duplicates.length > 0) {
      MySwal.fire({
        icon: "error",
        title: "Duplicate Emails",
        text: `The following email(s) are duplicated: ${[
          ...new Set(duplicates),
        ].join(", ")}`,
        confirmButtonColor: RESERVATION_COLOR,
      });
      this.setState({ [loadingKey]: false });
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const invalidEmails = emails.filter((email) => !emailRegex.test(email));

    if (invalidEmails.length > 0) {
      MySwal.fire({
        icon: "error",
        title: "Invalid Email Format",
        text: `The following email(s) appear to be invalid: ${invalidEmails.join(
          ", ",
        )}`,
        confirmButtonColor: RESERVATION_COLOR,
      });
      this.setState({ [loadingKey]: false });
      return;
    }

    try {
      const { data } = await this.api.post(
        {
          url: `/store/${store._id}/complimentary_tickets`,
          data: {
            tickets: filteredGuestList,
            event_date: moment(guestListActiveDate).format(DB_DATE_FORMAT),
            timeslot: moment(selectedSlot).format(DB_HOURS_FORMAT),
            withEmail,
            reInvite,
            ...(withEmail && { rsvp_deadline: rsvpDeadline }),
          },
        },
        {
          headers: {
            Authorization: `Basic ${window.btoa(store.brand.brand_url)}`,
          },
          baseURL: this.api.getBaseURL(),
        },
      );
      if (data) {
        this.updateGuestList(
          reInvite
            ? guestList.map((guest) =>
                guest._id === activeReInvite ? data[0] : guest,
              )
            : data,
          slotTickets,
        );
        MySwal.fire({
          icon: "success",
          title: "Success!",
          text: "Successfully created complimentary tickets!",
          confirmButtonColor: RESERVATION_COLOR,
        });
      }
    } catch (err) {
      this.handleEventError(err);
    } finally {
      const newState = { [loadingKey]: false };
      if (withEmail) {
        newState.showRsvpModal = false;
        newState.rsvpDeadline = null;
        newState.activeReInvite = null;
      }
      this.setState(newState);
    }
  };

  toggleAccordion = (key) => {
    this.setState((prevState) => {
      const { activeKeys } = prevState;
      if (activeKeys.includes(key)) {
        // Remove to close
        return { activeKeys: activeKeys.filter((k) => k !== key) };
      } else {
        // Add to open
        return { activeKeys: [...activeKeys, key] };
      }
    });
  };

  accordionOpen = (key, status) => {
    this.setState((prevState) => {
      const { activeKeys } = prevState;
      if (status) {
        if (!activeKeys.includes(key)) {
          return { activeKeys: [...activeKeys, key] };
        }
      } else {
        if (activeKeys.includes(key)) {
          return { activeKeys: activeKeys.filter((k) => k !== key) };
        }
      }
      return null; // No change needed
    });
  };

  formatSlotObject = (timeslots) => {
    if (!isEmpty(timeslots)) {
      return timeslots.map((slot) => {
        return {
          start_time: new Date(slot.start_time),
          end_time: new Date(slot.end_time),
          ...(this.props.isEdit && { _id: slot._id }),
        };
      });
    } else {
      return [];
    }
  };

  formatEventObject = () => {
    const { values } = this.state;
    const {
      event_name,
      start_date,
      end_date,
      delivery_address,
      currentPosition,
      capacity,
      price,
      image_url,
      description,
      status,
      available_days,
      ordering_cutoff,
      dress_code,
      cancellation_policy,
      blockout_dates,
      tickets,
      time_slots,
    } = values;

    return {
      name: event_name,
      image_url,
      description,
      capacity,
      price,
      available_days,
      ordering_cutoff,
      start_date: moment(start_date).startOf("day"),
      end_date: moment(end_date).endOf("day"),
      location: {
        type: "Point",
        coordinates: [currentPosition.lng, currentPosition.lat],
      },
      location_address: delivery_address,
      status,
      dress_code,
      cancellation_policy,
      blockout_dates,
      ticket_types: tickets,
      time_slots: this.formatSlotObject(time_slots),
    };
  };

  formatTimeSlots = (ticket, time_slots) => {
    if (!isEmpty(ticket)) {
      return ticket.time_slots.map((slot_id) => {
        const ret_val = time_slots.filter((time) => time._id === slot_id)[0];
        return {
          start_time: new Date(ret_val.start_time),
          end_time: new Date(ret_val.end_time),
          _id: ret_val._id,
          isStartValid: true,
          isEndValid: true,
        };
      });
    }
    return [];
  };

  formatTierGroup = (event) => {
    if (!isEmpty(event)) {
      const { tickets = [], time_slots = [] } = event;
      return tickets.map((tier) => {
        return {
          price: tier.item?.price,
          name: tier.item?.name,
          description: tier.item?.description,
          capacity: tier.capacity,
          time_slots: sortBy(this.formatTimeSlots(tier, time_slots), "_id"),
          isEdit: tier.item?.name.trim() === "",
          _id: tier._id,
        };
      });
    } else {
      return [];
    }
  };

  selectAllow = (selectInfo) => {
    let current = new Date(selectInfo.start);
    while (current < selectInfo.end) {
      const dStr = current.toISOString().slice(0, 10);
      if (this.state.values.blockout_dates.includes(dStr)) {
        return false;
      }
      current.setDate(current.getDate() + 1);
    }
    return true;
  };

  dateClick = (info) => {
    if (this.state.values.blockout_dates.includes(info.dateStr)) {
      this.calendarRef.current.getApi().unselect(); // Remove selection highlight
      return;
    } else {
      this.handleEventClick(info.dateStr);
    }
  };
  dateClickGuest = async (info) => {
    if (
      !this.state.values.available_days.includes(
        moment(info.date).isoWeekday() - 1,
      )
    ) {
      MySwal.fire({
        icon: "error",
        title: "Invalid Selection",
        text: "You can only select dates that are marked as active event days.",
        confirmButtonColor: RESERVATION_COLOR,
        confirmButtonText: "OK",
        showCancelButton: false,
      });
    } else {
      setTimeout(() => {
        this.guestCalendarRef.current.getApi().updateSize();
      }, 100);

      this.setState({ guestListActiveDate: info.date });
      const { time_slots, tickets } = this.state.values;
      if (time_slots.length > 1) {
        this.accordionOpen("guestCalendar", false);
        this.accordionOpen("guestSlot", true);
      } else {
        const slot = time_slots[0];
        const timeslot = slot.start_time;
        const start = moment(new Date(slot.start_time)).format("hh:mm a");
        const end = moment(new Date(slot.end_time)).format("hh:mm a");
        const guestList = await this.getComplimentaryTickets(slot.start_time);
        this.setState({
          selectedTimeSlot: `${start} - ${end}`,
          selectedSlot: timeslot,
          slotTickets: tickets,
        });

        this.accordionOpen("guestCalendar", false);
        this.updateGuestList(guestList, tickets);
        this.accordionOpen("guestListTable", true);
      }
    }
  };

  dayCellClassNames = (arg) => {
    const dateStr = format(arg.date, "yyyy-MM-dd");
    if (this.state.values.blockout_dates.includes(dateStr)) {
      return ["events-disabled-day"];
    }
    return [];
  };

  handleEventError = (err) => {
    if (err.hasOwnProperty("response")) {
      const { data = {} } = err.response,
        { error_message = {} } = data;
      if (!isEmpty(error_message)) {
        MySwal.fire({
          icon: "error",
          title: "Ooops!",
          text: error_message,
          confirmButtonColor: RESERVATION_COLOR,
          confirmButtonText: "OK",
          showCancelButton: false,
        });
      } else {
        this.handleError();
      }
    } else {
      this.handleError();
    }
  };

  onUpdateEvent = async () => {
    const { store, event } = this.state;

    try {
      return this.api
        .put(
          {
            url: `/store/${store._id}/event/${event._id}`,
            data: { event: this.formatEventObject() },
          },
          {
            headers: {
              Authorization: `Basic ${window.btoa(store.brand.brand_url)}`,
            },
            baseURL: this.api.getBaseURL(),
          },
        )
        .then(({ data }) => {
          if (data) {
            MySwal.fire({
              icon: "success",
              title: "Success!",
              text: "Successfully updated event!",
              confirmButtonColor: RESERVATION_COLOR,
              confirmButtonText: "Ok",
            }).then(async (result) => {
              if (result && result.isConfirmed) {
                await this.props.getData();
              }
            });
          }
        });
    } catch (err) {
      this.handleEventError(err);
    }
  };

  onCreateEvent = async () => {
    const { store } = this.state;
    try {
      this.api
        .post(
          {
            url: `/store/${store._id}/event`,
            data: { event: this.formatEventObject() },
          },
          {
            headers: {
              Authorization: `Basic ${window.btoa(store.brand.brand_url)}`,
            },
            baseURL: this.api.getBaseURL(),
          },
        )
        .then(({ data }) => {
          if (data) {
            MySwal.fire({
              icon: "success",
              title: "Success!",
              text: "Successfully created new event!",
              confirmButtonColor: RESERVATION_COLOR,
              confirmButtonText: "Ok",
            }).then((result) => {
              if (result && result.isConfirmed) {
                this.props.history.push(`/stores/${store._id}/events`);
              }
            });
          }
        });
    } catch (err) {
      this.setState({ isSubmitting: false });
      this.handleEventError(err);
    }
  };

  validateForm = () => {
    const value = this.state.values.event_name
      ? this.state.values.event_name.trim()
      : "";
    if (!value) {
      this.setState({
        isNameValid: false,
      });
    }
  };

  timeSlotFunction = async (slot, type) => {
    const { store, event } = this.state;

    const options = {
      headers: {
        Authorization: `Basic ${window.btoa(store.brand.brand_url)}`,
      },
      baseURL: this.api.getBaseURL(),
    };

    try {
      let response;
      if (type === "add") {
        response = await this.api.put(
          {
            url: `/store/${store._id}/event/${event._id}`,
            data: { event: { time_slots: [slot] } },
          },
          options,
        );
      } else if (type === "remove") {
        response = await this.api.delete(
          {
            url: `/store/${store._id}/event/${event._id}/slot/${slot._id}`,
          },
          options,
        );
      } else if (type === "update") {
        response = await this.api.put(
          {
            url: `/store/${store._id}/event/${event._id}/slot/${slot._id}`,
            data: { slot }, // use `data` for consistency
          },
          options,
        );
      }

      if (response?.data?.data) {
        return response.data.data;
      }
    } catch (err) {
      this.handleEventError(err);
    }
  };

  tierFunction = async (tier, type) => {
    const { store, event } = this.state;

    const options = {
      headers: {
        Authorization: `Basic ${window.btoa(store.brand.brand_url)}`,
      },
      baseURL: this.api.getBaseURL(),
    };

    try {
      let response;
      if (type === "add") {
        response = await this.api.post(
          {
            url: `/store/${store._id}/event/${event._id}/tier`,
            data: { tier },
          },
          options,
        );
      } else if (type === "remove") {
        response = await this.api.delete(
          {
            url: `/store/${store._id}/event/${event._id}/tier/${tier._id}`,
          },
          options,
        );
      } else if (type === "update") {
        response = await this.api.put(
          {
            url: `/store/${store._id}/event/${event._id}/tier/${tier._id}`,
            data: { tier }, // use `data` for consistency
          },
          options,
        );
      }

      if (response?.data?.data) {
        return response.data.data;
      }
    } catch (err) {
      console.error(err);
      this.handleEventError(err);
    }
  };

  bulkCancelInvites = async (invites) => {
    if (!invites || invites.length === 0) {
      return;
    }

    await Promise.all(
      invites.map((invite) =>
        this.api.put({
          url: `/orders/event/invites/${invite._id}`,
          data: { action: "cancel" },
        }),
      ),
    );
  };

  onSubmit = async (values, setSubmitting) => {
    const {
      file,
      isEdit,
      isVerifying,
      isNameValid,
      isEventDateValid,
      isEventTimeValid,
      isDescriptionValid,
      values: { delivery_address, image_url },
    } = this.state;
    if (isVerifying || !isNameValid || !isEventDateValid || !isEventTimeValid) {
      setSubmitting(false);
      return;
    }
    try {
      if (isEmpty(delivery_address)) {
        MySwal.fire({
          icon: "info",
          title: "Ooops",
          text: "Location pin cannot be empty",
          confirmButtonColor: RESERVATION_COLOR,
          confirmButtonText: "OK",
          showCancelButton: false,
        });
        setSubmitting(false);
        return;
      }
      if (isEmpty(image_url)) {
        MySwal.fire({
          icon: "info",
          title: "Ooops",
          text: "Header image cannot be empty.",
          confirmButtonColor: RESERVATION_COLOR,
          confirmButtonText: "OK",
          showCancelButton: false,
        });
        setSubmitting(false);
        return;
      }
      if (!isDescriptionValid) {
        MySwal.fire({
          icon: "info",
          title: "Ooops",
          text: "Event description cannot be empty.",
          confirmButtonColor: RESERVATION_COLOR,
          confirmButtonText: "OK",
          showCancelButton: false,
        });
        setSubmitting(false);
        return;
      }
      setSubmitting(true);
      if (file) {
        values.image_url = await this.handlePhotoUpload(this.state.file);
      }
      if (isEdit) {
        const { event, store, values: formValues } = this.state;

        const oldStartDate = moment(event.start_date).startOf("day");
        const currentStartDate = moment(formValues.start_date).startOf("day");
        const oldEndDate = moment(event.end_date).startOf("day");
        const currentEndDate = moment(formValues.end_date).startOf("day");

        const datesChanged =
          !oldStartDate.isSame(currentStartDate) ||
          !oldEndDate.isSame(currentEndDate);

        const availableDaysChanged = !lodashIsEqual(
          sortBy(event.available_days),
          sortBy(formValues.available_days),
        );

        const formatTimeSlots = (slots) =>
          sortBy(
            slots.map((ts) => ({
              start: moment(ts.start_time).format(DB_HOURS_FORMAT),
              end: moment(ts.end_time).format(DB_HOURS_FORMAT),
            })),
            ["start", "end"],
          );

        const oldTimeSlots = formatTimeSlots(event.time_slots);
        const newTimeSlots = formatTimeSlots(formValues.time_slots);

        const timeSlotsChanged = !lodashIsEqual(oldTimeSlots, newTimeSlots);

        const scheduleChanged =
          datesChanged || availableDaysChanged || timeSlotsChanged;

        if (scheduleChanged) {
          const proceed = await this.handleAffectedInvites({
            ...formValues,
          });

          if (!proceed) {
            setSubmitting(false);
            return;
          }
        }
        const eventForm = this.formatEventObject();
        const {
          available: prevAvailable,
          capacity: prevCapacity,
          start_date: prevStartDate,
          end_date: prevEndDate,
        } = event;
        const eventDays = eachDayOfInterval({
          start: new Date(prevStartDate),
          end: new Date(prevEndDate),
        });

        const {
          capacity: newCapacity,
          start_date: newStartDate,
          end_date: newEndDate,
        } = eventForm;

        // If yes, check if the new capacity is less than the available seats, if yes notify user
        const defaultNoLimit = 999999;
        const availableDrift =
          (prevCapacity * eventDays.length || defaultNoLimit) - prevAvailable;

        const newEventDays = eachDayOfInterval({
          start: new Date(newStartDate),
          end: new Date(newEndDate),
        });

        const newAvailable =
          newCapacity === 0
            ? defaultNoLimit
            : newCapacity * newEventDays.length - availableDrift;

        if (newAvailable < 1) {
          let message = `This update will result in a total available seat (${
            newCapacity * newEventDays.length
          }) that is less than the sold seats (${availableDrift}).`;

          if (newAvailable === 0) {
            message = `This update will set the available seat to ZERO (0).`;
          }

          const result = await MySwal.fire({
            icon: "warning",
            title: `Event have sold seats`,
            text: message,
            confirmButtonText: "Confirm",
            showCancelButton: true,
            cancelButtonText: "Abort",
            allowOutsideClick: false,
          });

          if (result.isConfirmed) {
            await this.onUpdateEvent();
            setSubmitting(false);
            return Promise.resolve();
          } else {
            setSubmitting(false);
            return Promise.resolve();
          }
        }

        await this.onUpdateEvent();
        setSubmitting(false);
      } else {
        this.onCreateEvent();
      }
    } catch (err) {
      setSubmitting(false);
      this.handleEventError(err);
    }
  };

  handlePhotoUpload = async (file) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      const { data } = await this.fileapi.post({
        url: "/util/upload-to-aws/events",
        data: formData,
      });
      return data.filePath;
    } catch (error) {
      throw error;
    }
  };

  onVerifyEventName = async (value = "") => {
    if (isEmpty(value)) {
      this.setState({ isVerifying: false, isNameValid: false });
      return;
    }
    const { store, event } = this.state;

    const result = await fetchData(
      "get",
      `/store/${store._id}/verify-event-name?search=${value}`,
    );

    const isNameExists = result.data.existing && event?._id !== result.data?.id;
    this.setState({ isVerifying: false, isNameValid: !isNameExists });

    return isNameExists;
  };

  debounceVerifyEventName = debounce((value) => {
    this.onVerifyEventName(value);
  }, 500);

  onChange = async (e) => {
    const { name = "" } = e.target;
    if (name === "event_name") {
      const val = e.target.value;
      const isCountValid = val.trim().length !== EVENT_NAME_LIMIT;
      if (isCountValid) {
        this.setState({ isVerifying: true });
        await this.debounceVerifyEventName(e.target.value);
      }
      this.setState({
        isEventNameCountValid: isCountValid,
      });
    }
    if (name === "description") {
      this.setState({ isDescriptionValid: !isEmpty(e.target.value) });
    }
  };

  onDressCodeChange = async (e) => {
    let { values } = this.state;
    const { name = "" } = e.target;
    if (name === "dress_code") {
      if (e.target.checked) {
        values.dress_code = "Casual";
      } else {
        values.dress_code = "";
      }
      this.setState({
        values,
      });
    }
  };

  onStatusChange = async (e) => {
    const { isEdit, event, values } = this.state;
    const { name = "", checked } = e.target;

    if (name === "status") {
      if (e.target.checked) {
        MySwal.fire({
          icon: "info",
          title: "Event will be public",
          text: "This will allow your customers to search for and buy tickets for this event.",
          confirmButtonColor: RESERVATION_COLOR,
          confirmButtonText: "OK",
          showCancelButton: false,
        });
      } else {
        if (isEdit) {
          const { available, capacity } = event;
          if (available < capacity) {
            const result = await MySwal.fire({
              icon: "warning",
              title: `Event will be hidden and not be available for purchase`,
              text: `We noticed there are already purchases for this event. Do you want to continue?`,
              confirmButtonText: "Confirm",
              showCancelButton: true,
              cancelButtonText: "Abort",
              allowOutsideClick: false,
            });

            if (result.isDismissed) return;
          } else {
            MySwal.fire({
              icon: "info",
              title: "Event will be private",
              text: "Event will be hidden and not be available for purchase.",
              confirmButtonColor: RESERVATION_COLOR,
              confirmButtonText: "OK",
              showCancelButton: false,
            });
          }
        }
      }
      values.status = checked ? "public" : "private";
      this.setState({
        values,
      });
    }
  };

  onPromoteStatusChange = async (e) => {
    const { values, store, event } = this.state;
    const { name = "", checked } = e.target;

    let success = false;

    if (name === "promote") {
      if (e.target.checked) {
        const dateFormat = "yyyy-MM-dd";
        // Start is today
        const startDate = format(new Date(), dateFormat);
        // If no end date, default to 1 week
        const endDate = event.end_date
          ? new Date(event.end_date)
          : addDays(new Date(), 7);

        const result = await fetchData(
          "post",
          `/store/${store._id}/event/${event._id}/promote`,
          {
            startDate,
            endDate: format(endDate, dateFormat),
            title: `Promotion for ${event.name}`,
            description: `Promotion created`,
          },
        );

        console.log("result", result);

        if (result?.data?.success) {
          MySwal.fire({
            icon: "info",
            title: "Event will be promoted on Pickup Marketplace App",
            text: "This will allow your customers to have more visibility on your event.",
            confirmButtonColor: RESERVATION_COLOR,
            confirmButtonText: "OK",
            showCancelButton: false,
          });

          success = true;
        }
      } else {
        const result = await fetchData(
          "post",
          `/store/${store._id}/event/${event._id}/promote/disable`,
          {},
        );

        if (result?.data?.success) {
          MySwal.fire({
            icon: "info",
            title: "Promotion disabled",
            text: "Users can still search for and purchase tickets for this event.",
            confirmButtonColor: RESERVATION_COLOR,
            confirmButtonText: "OK",
            showCancelButton: false,
          });

          success = true;
        }
      }

      if (success) {
        values.promote = checked;
        this.setState({
          values,
        });
      }
    }
  };
  handleDayClick = (index, e) => {
    e.currentTarget.blur();
    const { values } = this.state;
    const currentAvailableDays = [...values.available_days];
    const dayIndex = currentAvailableDays.indexOf(index);
    if (dayIndex > -1) {
      currentAvailableDays.splice(dayIndex, 1);
    } else {
      currentAvailableDays.push(index);
    }
    values["available_days"] = currentAvailableDays;
    this.setState({
      values,
    });
  };
  handleEventClick = (clicked_date) => {
    Swal.fire({
      title: `<h5 class="font-weight-bolder">You're blocking off ${moment(
        clicked_date,
        "YYYY-MM-DD",
      ).format("dddd MMM DD, YYYY")}</h5>`,
      text: `your event will not be visible or bookable on this date.`,
      showCancelButton: true,
      confirmButtonText: "Confirm",
      cancelButtonText: "No",
      confirmButtonColor: "#8950FC",
    }).then((result) => {
      if (result.isConfirmed) {
        const { values } = this.state;
        const blockoutDates = [...values.blockout_dates, clicked_date];
        values.blockout_dates = blockoutDates;
        this.setState({ values });
      }
    });
  };

  handleGuestChange = (event) => {
    const { name, value, dataset } = event.target;
    const index = parseInt(dataset.index, 10);
    const { guestList: currentGuestList } = this.state.values;
    const guestList = JSON.parse(JSON.stringify(currentGuestList)); // Deep copy
    const updatedGuestList = [...guestList];
    const originalGuest = { ...updatedGuestList[index] }; // Save the original state of the guest row

    updatedGuestList[index][name] = value;

    // Perform validation if quantity or ticketType is changed
    if (name === "quantity") {
      const guest = updatedGuestList[index];
      const ticketType = guest.ticketType;
      const quantity = parseInt(guest.quantity, 10) || 0;

      if (ticketType && quantity > 0) {
        const { slotTickets } = this.state;
        const ticketInfo = slotTickets.find(
          (ticket) => ticket.item._id === ticketType,
        );

        if (ticketInfo && ticketInfo.capacity > 0) {
          const totalQuantityForType = updatedGuestList
            .filter(
              (g) =>
                g.ticketType === ticketType && g.invite_status !== "rejected",
            )
            .reduce((acc, g) => acc + (parseInt(g.quantity, 10) || 0), 0);

          if (totalQuantityForType > ticketInfo.capacity) {
            MySwal.fire({
              icon: "error",
              title: "Capacity Exceeded",
              text: `The quantity for "${ticketInfo.item.name}" exceeds the available capacity of ${ticketInfo.capacity}.`,
              confirmButtonColor: RESERVATION_COLOR,
            });

            // Revert the guest row to its original state before the invalid change
            this.setState((prevState) => {
              const revertedGuestList = [...prevState.values.guestList];
              revertedGuestList[index] = originalGuest;
              return {
                values: {
                  ...prevState.values,
                  guestList: revertedGuestList,
                },
              };
            });
            return;
          }
        }
      }
    }

    this.setState({
      values: { ...this.state.values, guestList: updatedGuestList },
    });
  };

  handleEditGuest = (index) => {
    this.setState((prevState) => {
      const guestList = [...prevState.values.guestList];
      guestList[index].isEditing = true;
      return {
        values: {
          ...prevState.values,
          guestList,
        },
      };
    });
  };

  handleResendInvite = async (guest_id) => {
    if (guest_id) {
      this.setState({ activeReInvite: guest_id });
      this.openRsvpModal();
    } else {
      MySwal.fire(
        "Error",
        "Cannot resend invite for an unsaved guest.",
        "error",
      );
    }
  };

  handleGuestAction = async (guest_id, action) => {
    if (!guest_id) return;

    const actionConfig = {
      cancel: {
        text: "This will cancel the invitation.",
        confirmText: "Yes, cancel it!",
      },
      reject: {
        text: "This will reject the invitation.",
        confirmText: "Yes, reject it!",
      },
    };

    const { text, confirmText } = actionConfig[action] || {};
    if (!text) return; // invalid action safeguard

    const result = await MySwal.fire({
      title: "Are you sure?",
      text,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: RESERVATION_COLOR,
      cancelButtonColor: "#d33",
      confirmButtonText: confirmText,
    });

    if (result.isConfirmed) {
      await this.updateInvite(guest_id, action);
    }
  };

  handleCopyToClipboard = (text) => {
    if (!navigator.clipboard) {
      MySwal.fire({
        icon: "error",
        title: "Clipboard Not Supported",
        text: "Your browser does not support this feature.",
        confirmButtonColor: RESERVATION_COLOR,
      });
      return;
    }
    navigator.clipboard.writeText(text).then(() => {
      MySwal.fire({
        toast: true,
        position: "center",
        icon: "success",
        title: "Link copied to clipboard!",
        showConfirmButton: false,
        timer: 1500,
      });
    });
  };

  updateGuestList(guestListMap, slotTickets) {
    let guestList = guestListMap.map((g) => ({ ...g, isEditing: false }));
    const { values } = this.state;
    if (guestListMap.length < 10) {
      const emptyGuests = Array(10 - guestListMap.length)
        .fill()
        .map(() => ({
          firstName: "",
          lastName: "",
          email: "",
          contact: "",
          ticketType: slotTickets.length ? slotTickets[0].item._id : "",
          quantity: "",
        }));
      guestList = guestList.concat(emptyGuests);
    }

    values.guestList = guestList;
    this.setState({ values });
  }

  async addTimeSlotCount() {
    const { values, event } = this.state;
    const { time_slots } = values;
    let start_time = "16:00";
    let end_time = "17:00";

    if (time_slots.length > 0) {
      const array_len = time_slots.length;
      start_time = moment(new Date(time_slots[array_len - 1].start_time)).add(
        1,
        "hours",
      );
      end_time = moment(new Date(time_slots[array_len - 1].end_time)).add(
        1,
        "hours",
      );
    }

    const duplicate_start_time =
      values.time_slots.length > 0
        ? values.time_slots.findIndex(
            (time, idx) =>
              idx !== values.time_slots.length - 1 &&
              time.start_time === start_time,
          ) > -1
        : false;

    const ticket_option = {
      start_time: new Date(start_time),
      end_time: new Date(end_time),
      isStartValid: !duplicate_start_time,
      isEndValid: true,
    };

    if (isEmpty(event)) {
      values["time_slots"].push(ticket_option);
      this.setState({
        ...values,
      });
    } else {
      const updated_event = await this.timeSlotFunction(ticket_option, "add");
      if (updated_event?.time_slots?.length > 0) {
        const newTimeSlot = {
          ...updated_event.time_slots.at(-1),
          isStartValid: !duplicate_start_time,
          isEndValid: true,
        };
        values.time_slots = [...values.time_slots, newTimeSlot];
        this.setState({ values });
      }
    }
  }

  async removeTimeSlots(index) {
    const { values, isEdit } = this.state;
    const slotToRemove = values.time_slots[index];

    // Check if the timeslot is used in any ticket tier
    const isSlotUsed = values.tierGroup.some((tier) => {
      if (isEdit) {
        return tier.time_slots.some((ts) => ts._id === slotToRemove._id);
      }
      // For new events, time_slots in tiers are indices
      return tier.time_slots.includes(index);
    });

    if (isSlotUsed) {
      MySwal.fire({
        icon: "error",
        title: "Cannot Remove Timeslot",
        text: "This timeslot is currently being used by one or more ticket types. Please remove it from the ticket types first.",
        confirmButtonColor: RESERVATION_COLOR,
      });
      return;
    }

    const newTimeSlots = values.time_slots.filter((_, i) => i !== index);

    if (isEdit) {
      const proceed = await this.handleAffectedInvites(
        {
          ...values,
          time_slots: newTimeSlots,
        },
        true,
      );

      if (!proceed) {
        return;
      }
      await this.timeSlotFunction(slotToRemove, "remove");
    }

    const updatedTierGroup = values.tierGroup.map((tier) => {
      const { start_time, end_time } = slotToRemove;
      const newTierTimeSlots = tier.time_slots.filter(
        (t) =>
          !isEqual(t.start_time, start_time) && !isEqual(t.end_time, end_time),
      );
      return { ...tier, time_slots: newTierTimeSlots };
    });

    this.setState({
      values: {
        ...values,
        time_slots: newTimeSlots,
        tierGroup: updatedTierGroup,
      },
    });
  }

  async addTier() {
    const { values, event = {} } = this.state;
    const default_tier = {
      name: "",
      price: "",
      description: "",
      capacity: "",
      time_slots: [this.props.isEdit ? event.time_slots[0] : 0],
      isEdit: this.props.isEdit ? false : true,
      isAdded: true,
    };
    if (isEmpty(event)) {
      values["tierGroup"].push(default_tier);
      this.setState({
        values,
      });
    } else {
      const updated_event = await this.tierFunction(default_tier, "add");

      const { tickets = [] } = updated_event;
      const new_tier = tickets[tickets.length - 1];

      const newTier = {
        _id: new_tier._id,
        name: new_tier.item.name,
        item: new_tier.item,
        description: new_tier.item.description,
        price: new_tier.item.price,
        quantity: 0,
        capacity: new_tier.capacity,
        time_slots: [updated_event.time_slots[0]],
        isTouched: false,
        isEdit: true,
      };

      this.setState((prevState) => ({
        values: {
          ...prevState.values,
          tierGroup: [...(prevState.values.tierGroup || []), newTier],
        },
      }));
    }
  }

  onAddTimeSlot(tier_idx, time_idx, isChecked) {
    const { values } = this.state;
    const { tierGroup, time_slots } = values;
    const isEdit = this.props.isEdit;

    if (tierGroup.length > 0) {
      if (isChecked) {
        const idx = isEdit
          ? values.tierGroup[tier_idx].time_slots.findIndex(
              ({ _id }) => _id === time_idx,
            )
          : values.tierGroup[tier_idx].time_slots.findIndex(
              (id) => id === time_idx,
            );
        values.tierGroup[tier_idx].time_slots.splice(idx, 1);
      } else {
        const time_index = isEdit
          ? time_slots.findIndex((time) => time._id === time_idx)
          : time_idx;

        if (isEdit) {
          const time = time_slots[time_index];
          const isExisting =
            values.tierGroup[tier_idx].time_slots.findIndex(
              (tier) => tier._id === time._id,
            ) > -1;
          if (!isExisting) {
            values.tierGroup[tier_idx].time_slots.push(time_slots[time_index]);
            values.tierGroup[tier_idx].time_slots = sortBy(
              values.tierGroup[tier_idx].time_slots,
              "_id",
            );
          }
        } else {
          values.tierGroup[tier_idx].time_slots.push(time_index);
          values.tierGroup[tier_idx].time_slots =
            values.tierGroup[tier_idx].time_slots.sort();
        }
      }
    }
    this.setState({ values });
  }

  async onSaveTicketType(tier_idx) {
    const { values } = this.state;
    const { tierGroup, tickets } = values;

    const tier = tierGroup[tier_idx];

    if (tier) {
      const { _id = "" } = tier;
      if (this.props.isEdit) {
        const originalTier = this.state.event.tickets.find(
          (t) => t._id === _id,
        );

        if (originalTier) {
          const originalSlotIds = new Set(
            originalTier.time_slots.map((ts) => ts.toString()),
          );
          const newSlotIds = new Set(
            tier.time_slots.map((ts) => ts._id.toString()),
          );

          const removedSlotIds = [...originalSlotIds].filter(
            (id) => !newSlotIds.has(id),
          );

          if (removedSlotIds.length > 0) {
            const { data } = await this.api.get(
              `/store/${this.state.store._id}/event/check-dependencies?event_id=${this.state.event._id}&tier_id=${_id}`,
            );

            if (data.total > 0) {
              const result = await MySwal.fire({
                icon: "warning",
                title: "This change affects existing orders",
                text: `Changing time slots for this ticket type will affect ${data.total} existing order(s). Affected orders will be cancelled. Do you want to proceed?`,
                showCancelButton: true,
                confirmButtonText: "Yes, proceed",
                cancelButtonText: "No, cancel",
                confirmButtonColor: RESERVATION_COLOR,
              });

              if (!result.isConfirmed) {
                // Revert isEdit to true to allow user to continue editing
                const { values } = this.state;
                values.tierGroup[tier_idx] = { ...tier, isEdit: true };
                this.setState({
                  values,
                });
                return;
              } else {
                await this.bulkCancelInvites(data.invites);
              }
            }
          }
        }
      }

      let new_ticket = {
        ...tier,
        isAdded: false,
      };

      values.tierGroup[tier_idx] = { ...tier, isEdit: false };

      if (this.props.isEdit) {
        const updated_tier_item = await this.tierFunction(tier, "update");
        new_ticket = {
          ...new_ticket,
          item: updated_tier_item,
        };
      }
      const current_ticket_idx = this.props.isEdit
        ? tickets.findIndex((tier) => tier._id === _id)
        : tier_idx;
      if (current_ticket_idx === -1) {
        values.tickets.push(new_ticket);
      } else {
        values.tickets[current_ticket_idx] = new_ticket;
      }
    }
    this.setState({
      values,
    });
  }
  onEditTicket(index) {
    const { values } = this.state;
    const { tierGroup } = values;
    const edit_idx = tierGroup.findIndex((tier) => tier.isEdit);
    if (tierGroup[index]) {
      if (edit_idx > -1) {
        tierGroup[edit_idx].isEdit = false;
      }
      tierGroup[index].isEdit = true;
      this.setState({
        values,
      });
    }
  }

  onRemoveTicket = async (index) => {
    const { values, store, event } = this.state;
    const { tierGroup, tickets } = values;
    const tierToRemove = tierGroup[index];

    if (!tierToRemove) return;

    if (tierToRemove._id) {
      try {
        const { data } = await this.api.get(
          `/store/${store._id}/event/check-dependencies?event_id=${event._id}&tier_id=${tierToRemove._id}`,
        );

        if (data.total > 0) {
          const result = await MySwal.fire({
            icon: "warning",
            title: "Ticket Has Orders",
            text: `This ticket type has ${data.total} associated order(s). Deleting it will also cancel these orders. Do you want to proceed?`,
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "No, keep it",
            confirmButtonColor: RESERVATION_COLOR,
          });

          if (!result.isConfirmed) {
            return;
          }
        }
      } catch (err) {
        this.handleEventError(err);
        return;
      }
    }

    const proceedWithRemoval = async () => {
      if (tierToRemove._id) {
        await this.tierFunction(tierToRemove, "remove");
      }

      const newTickets = tierToRemove._id
        ? tickets.filter((t) => t._id !== tierToRemove._id)
        : tickets.filter((_, i) => i !== index);

      const newTierGroup = tierGroup.filter((_, i) => i !== index);

      this.setState({
        values: {
          ...values,
          tickets: newTickets,
          tierGroup: newTierGroup,
        },
      });
    };

    await proceedWithRemoval();
  };

  handleHighlightForm() {
    const elem = document.getElementById("event-ticket-form");
    if (elem) {
      elem.className += " highlight-ticket-form";
      setTimeout(() => {
        elem.classList.remove("highlight-ticket-form");
      }, 2000);
    }
  }

  formatTicketString(tier) {
    const price_str =
      Number(tier.price) === 0 ? "FREE" : `Php ${parseInt(tier.price)}`;
    return `${tier.name} • ${price_str}`;
  }

  render() {
    const {
      values,
      isSubmitting,
      isNameValid,
      isVerifying,
      isEventDateValid,
      isEventTimeValid,
      isDescriptionValid,
      activeKeys,
      isSavingForLater,
      isSendingInvites,
      isOneDayEvent,
      guestListActiveTab,
      loadingSlotId,
      eventFrequency,
      showInviteLinkModal,
      initialValues,
    } = this.state;

    const isEventEnded = isPast(new Date(values.end_date));

    const eventDurationToggle = activeKeys.includes("0");
    const eventTimeOptionsToggle = activeKeys.includes("1");
    const eventTicketsToggle = activeKeys.includes("2");
    const eventLocationToggle = activeKeys.includes("3");
    const eventGuestListToggle = activeKeys.includes("4");
    const BlockOutDatesToggle = activeKeys.includes("5");
    const eventGuestCalendarToggle = activeKeys.includes("guestCalendar");
    const guestSlotToggle = activeKeys.includes("guestSlot");
    const guestListToggle = activeKeys.includes("guestListTable");
    const actions = {
        handleFeedbackError: this.handleFeedbackError,
        isTouched: this.isTouched,
      },
      inputActions = {
        onChange: this.handleOnChange,
        onBlur: this.handleOnBlur,
        // Add a generic onChange that also checks for unsaved changes
        onChange: (e) => this.handleOnChange(e),
      },
      tableInputActions = {
        onChange: this.handleGuestChange,
      };

    const isGuestRowFilled = (guest) =>
      guest.firstName?.trim() ||
      guest.lastName?.trim() ||
      guest.email?.trim() ||
      guest.contact?.trim() ||
      guest.quantity?.trim();

    const hasUnsavedChanges = (() => {
      if (!initialValues) return false;
      const fieldsToCompare = [
        "event_name",
        "event_location",
        "start_date",
        "end_date",
        "description",
        "status",
        "dress_code",
        "cancellation_policy",
        "blockout_dates",
        "tickets",
        "time_slots",
        "available_days",
        "tierGroup",
        "eventFrequency",
        "isOneDayEvent",
      ];

      for (const key of fieldsToCompare) {
        if (
          !lodashIsEqual(
            JSON.stringify(values[key]),
            JSON.stringify(initialValues[key]),
          )
        ) {
          return true;
        }
      }
      return false;
    })();

    const allGuests = this.state.values.guestList.filter(isGuestRowFilled);

    const sumQuantity = (guests) =>
      guests.reduce((sum, g) => sum + (Number(g.quantity) || 0), 0);

    const counts = {
      all: sumQuantity(allGuests),
      attending: sumQuantity(
        allGuests.filter((g) => g.invite_status === "confirmed"),
      ),
      invited: sumQuantity(
        allGuests.filter((g) => g.invite_status === "pending"),
      ),
      rejected: sumQuantity(
        allGuests.filter((g) => g.invite_status === "rejected"),
      ),
    };

    let displayedGuests;
    if (guestListActiveTab === "all") {
      displayedGuests = this.state.values.guestList;
    } else {
      const statusMap = {
        attending: "confirmed",
        invited: "pending",
        rejected: "rejected",
      };
      const targetStatus = statusMap[guestListActiveTab];
      displayedGuests = allGuests.filter(
        (guest) => guest.invite_status === targetStatus,
      );
    }

    const isGuestEmpty = ({
      firstName,
      lastName,
      email,
      contact,
      quantity,
    }) => {
      // Check if any other field has value
      return !(firstName || lastName || email || contact || quantity);
    };

    const isDisabled = (guest) => {
      const { invite_status, isEditing, partner_identifier } = guest;
      if (isGuestEmpty(guest)) return false;
      if (partner_identifier) return true; // Disable if it's a marketplace booking
      return invite_status && !isEditing;
    };
    const renderGuestListTable = (guests) => {
      const colSpan = 10 + (this.state.slotTickets.length > 0 ? 1 : 0);
      const guestRows = guests.map((guest, idx) => (
        <tr key={`guest-list-${idx}`}>
          <td>{idx + 1}</td>
          <td>
            <Form.Control
              name="firstName"
              data-index={idx}
              disabled={isDisabled(guest)}
              value={guest.firstName}
              {...tableInputActions}
            />
          </td>
          <td>
            <Form.Control
              name="lastName"
              data-index={idx}
              disabled={isDisabled(guest)}
              value={guest.lastName}
              {...tableInputActions}
            />
          </td>
          <td>
            <Form.Control
              name="email"
              data-index={idx}
              disabled={isDisabled(guest)}
              value={guest.email}
              {...tableInputActions}
            />
          </td>
          <td>
            <Form.Control
              name="contact"
              data-index={idx}
              disabled={isDisabled(guest)}
              value={guest.contact}
              {...tableInputActions}
            />
          </td>

          {this.state.slotTickets.length > 0 && (
            <td>
              <Form.Control
                as="select"
                name="ticketType"
                data-index={idx}
                disabled={isDisabled(guest)}
                value={guest.ticketType}
                {...tableInputActions}
              >
                {this.state.slotTickets.map(
                  ({ item: { _id, name, price } }) => (
                    <option key={_id} value={_id}>
                      {name} {price > 0 && ` •  P${price}`}
                    </option>
                  ),
                )}
              </Form.Control>
            </td>
          )}
          <td>
            <Form.Control
              name="quantity"
              type="number"
              data-index={idx}
              min={1}
              value={guest.quantity}
              disabled={isDisabled(guest)}
              {...tableInputActions}
            />
          </td>
          <td className="align-middle text-center">
            {isGuestEmpty(guest) ? (
              <span className="text-muted">-</span>
            ) : (
              <>
                {guest.partner_identifier ? (
                  <i
                    className="fas fa-store-alt text-success"
                    title="Booked from Marketplace"
                  />
                ) : guest.rsvp_deadline ? (
                  moment(guest.rsvp_deadline).format("MMM DD")
                ) : (
                  <span className="text-muted">-</span>
                )}
              </>
            )}
          </td>
          <td className="align-middle">
            {isGuestEmpty(guest) ? (
              <span className="text-muted">-</span>
            ) : (
              <>
                {guest.invite_status === "confirmed" ? (
                  <i
                    className="fas fa-check-circle text-success"
                    title="Confirmed"
                    style={{ fontSize: "1.2em" }}
                  />
                ) : guest.invite_status === "pending" ? (
                  <i
                    className="fas fa-clock text-warning"
                    title="Pending"
                    style={{ fontSize: "1.2em" }}
                  />
                ) : guest.invite_status === "rejected" ? (
                  <i
                    className="fas fa-times-circle text-danger"
                    title="Rejected"
                    style={{ fontSize: "1.2em" }}
                  />
                ) : (
                  <span className="text-muted">-</span>
                )}
              </>
            )}
          </td>
          <td className="align-middle">
            {guest.invite_link && guest.invite_status ? (
              <Button
                variant="link"
                className="btn-icon btn-sm p-0"
                onClick={() => this.handleCopyToClipboard(guest.invite_link)}
                title="Copy invite link"
              >
                <i
                  className="fas fa-clipboard"
                  style={{ color: RESERVATION_COLOR }}
                ></i>
              </Button>
            ) : (
              "-"
            )}
          </td>
          <td>
            {guest.invite_status && (
              <Dropdown>
                <Dropdown.Toggle
                  as="button"
                  className="btn btn-clean btn-hover-info btn-sm btn-icon no-caret"
                >
                  <i className="ki ki-bold-more-hor" />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item
                    disabled={
                      guest.invite_status === "confirmed" ||
                      (!guest.invite_status && !guest.rsvp_deadline)
                    }
                    onClick={() => this.handleEditGuest(idx)}
                  >
                    Edit
                  </Dropdown.Item>
                  {guest.invite_status && (
                    <>
                      <Dropdown.Divider />
                      <Dropdown.Header>Ticket Actions</Dropdown.Header>
                      <Dropdown.Item
                        onClick={async () =>
                          await this.handleGuestAction(guest._id, "reject")
                        }
                        disabled={guest.invite_status === "rejected"}
                      >
                        Reject
                      </Dropdown.Item>

                      <Dropdown.Item
                        onClick={async () =>
                          await this.handleResendInvite(guest._id)
                        }
                        disabled={guest.invite_status !== "rejected"}
                      >
                        Re-Invite
                      </Dropdown.Item>
                    </>
                  )}
                  <Dropdown.Item
                    className={
                      guest.invite_status !== "confirmed" && "text-danger"
                    }
                    onClick={async () =>
                      await this.handleGuestAction(guest._id, "cancel")
                    }
                    disabled={guest.invite_status === "confirmed"}
                  >
                    {guest._id ? "Cancel Invite" : "Remove"}
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            )}
          </td>
        </tr>
      ));
      return (
        <table className="table text-center">
          <thead className="table-light">
            <tr>
              <th style={{ width: "5%" }}>#</th>
              <th style={{ width: "15%" }}>First Name</th>
              <th style={{ width: "15%" }}>Last Name</th>
              <th style={{ width: "20%" }}>Email</th>
              <th style={{ width: "15%" }}>Contact Number</th>

              {this.state.slotTickets.length > 0 && (
                <th style={{ width: "25%" }}>Ticket Type</th>
              )}
              <th style={{ width: "10%" }}>Quantity</th>
              <th style={{ width: "10%" }}>RSVP Deadline</th>
              <th style={{ width: "10%" }}>Status</th>
              <th style={{ width: "10%" }}>Invite Link</th>
              <th style={{ width: "5%" }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {guests.length > 0 ? (
              guestRows
            ) : (
              <tr>
                <td colSpan={colSpan} className="text-center p-5 text-muted">
                  <SVG
                    className="h-100px"
                    src={toAbsoluteUrl("/media/svg/illustrations/bg-4.svg")}
                  />
                  <p>No guests to display.</p>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      );
    };

    const getDayDifference = (start, end, availability, blockout_dates) => {
      const days_available = eachDayOfInterval({
        start: new Date(start),
        end: new Date(end),
      })
        .filter(
          (date) =>
            !blockout_dates.includes(
              moment(new Date(date)).format("YYYY-MM-DD"),
            ),
        )
        .filter((date) =>
          availability.includes(
            getDay(new Date(date)) === 0 ? 6 : getDay(new Date(date)) - 1,
          ),
        );

      return days_available.length;
    };

    const onPreviewClick = async () => {
      try {
        const { store, event } = this.state;
        const { data } = await this.api.get(
          `/store/${store._id}/event/${event._id}/preview_url`,
        );
        if (data && data.url) {
          window.open(data.url, "_blank");
        }
      } catch (err) {
        MySwal.fire({
          icon: "error",
          title: "Ooops!",
          text: `Something went wrong`,
          confirmButtonColor: RESERVATION_COLOR,
          confirmButtonText: "OK",
          showCancelButton: false,
        });
      }
    };

    return (
      <Form onSubmit={this.handleOnSubmit} ref={this.formRef}>
        <style>
          {`
    
          .rmdp-week-day {
            color: ${RESERVATION_COLOR} !important;
            font-weight: bold;
          }
          .rmdp-arrow {
            border: solid ${RESERVATION_COLOR};
            border-width: 0 2px 2px 0;
          }
          .rmdp-arrow-container:hover {
              background-color: ${RESERVATION_COLOR} !important;
          }
          .purple-tabs .nav-link.active, .purple-tabs .nav-item.show .nav-link {
            color: ${RESERVATION_COLOR};
            background-color: #fff;
            border-color: #dee2e6 #dee2e6 #fff;
            border-bottom: 2px solid ${RESERVATION_COLOR};
          }
          .purple-tabs .nav-link:not(.active):hover {
            color: ${RESERVATION_COLOR};
          }
          .rsvp-datepicker-wrapper .react-datepicker {
           width: 100% !important;
            font-family: "Poppins", "sans-serif";
          }
           .rsvp-datepicker-wrapper .react-datepicker-inline {
             width: 100% !important;
            font-family: "Poppins", "sans-serif";
          }
          .rsvp-datepicker-wrapper .react-datepicker__header {
            background-color: ${RESERVATION_COLOR};
            color: white;
          }

          .rsvp-datepicker-wrapper .react-datepicker__month-container {
            width: 100% !important;
            font-family: "Poppins", "sans-serif";
          }
            
          .rsvp-datepicker-wrapper .react-datepicker__day-names, .react-datepicker__week {
            display:flex;
            justify-content: space-around;
          }

          .rsvp-date-wrapper .react-datepicker__day-name, .react-datepicker__day, .react-datepicker__time-name {
            font-size: 1rem;
          }

          .rsvp-datepicker-wrapper .react-datepicker__current-month,
          .rsvp-datepicker-wrapper .react-datepicker__day-name {
            color: white;
            font-weight: 400;
          }
          .rsvp-datepicker-wrapper .react-datepicker__day--selected,
          .rsvp-datepicker-wrapper .react-datepicker__day--keyboard-selected {
            background-color: ${RESERVATION_COLOR};
            color: white;
          }
          .rsvp-datepicker-wrapper .react-datepicker__day:hover {
            background-color: #e3d8ff;
          }
          .rsvp-datepicker-wrapper .react-datepicker__navigation-icon::before {
            border-color: white;
          }
          .no-caret.dropdown-toggle::after {
            display: none;
          }

        `}
        </style>
        <Row>
          <Col sm={8}>
            <Card className={`card-custom mb-4`}>
              <Card.Body className="p-10 px-8">
                <Dropzone
                  onDrop={async (acceptedFiles) => {
                    const file = acceptedFiles[0];
                    const preview = await toBase64(file);
                    let { values = {} } = this.state;
                    values.image_url = preview;
                    this.setState({ file, values });
                  }}
                  accept={{ "image/*": [] }}
                  multiple={false}
                >
                  {({ getRootProps, getInputProps }) => (
                    <section>
                      <div {...getRootProps()} className="dropzone-base-style">
                        <input {...getInputProps()} />

                        {/* Background image preview */}
                        {this.state.values?.image_url && (
                          <img
                            src={this.state.values.image_url}
                            alt="Uploaded preview"
                            style={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                              zIndex: 1,
                            }}
                          />
                        )}

                        <div
                          style={{
                            position: "relative",
                            zIndex: 2,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "100%",
                            width: "100%",
                            color: "#fff",
                            textAlign: "center",
                          }}
                        >
                          {this.state.values?.image_url ? (
                            <button
                              type="button"
                              className="rounded-circle d-flex justify-content-center align-items-center"
                              style={{
                                position: "absolute",
                                bottom: "12px",
                                right: "12px",
                                width: "40px",
                                height: "40px",
                                zIndex: 3,
                                backgroundColor: RESERVATION_COLOR,
                                borderColor: RESERVATION_COLOR,
                              }}
                            >
                              <i
                                className="fas fa-pen"
                                style={{ fontSize: "18px", color: "#fff" }}
                              />
                            </button>
                          ) : (
                            <>
                              <h5
                                className="ml-8 mt-12 mb-2 font-weight-bolder"
                                style={{
                                  color: RESERVATION_COLOR,
                                }}
                              >
                                Add header image of your event
                              </h5>
                              <Button
                                variant="info-outline"
                                className="rounded-circle events-image-header-button mb-12"
                              >
                                +
                              </Button>
                            </>
                          )}
                        </div>
                      </div>
                    </section>
                  )}
                </Dropzone>

                <div className="d-flex flex-column flex-grow-1">
                  <h5 className="mt-8 font-weight-bolder">
                    <span className="border-bottom border-2 border-info font-weight-boldest">
                      Event
                    </span>
                  </h5>
                  <FormItem
                    customFormControl
                    name={"event_name"}
                    inputProps={{
                      name: "event_name",
                      value: values["event_name"],
                    }}
                    actions={actions}
                    inputActions={inputActions}
                    type={"text"}
                    noLabel
                    normal
                    custom={
                      <Form.Control
                        name="event_name"
                        placeholder="Add your event name"
                        maxLength={50}
                        value={this.state.values["event_name"]}
                        style={{
                          borderColor: RESERVATION_COLOR,
                          fontSize: "25px",
                          fontWeight: "bold",
                        }}
                        {...(actions.isTouched("event_name") && {
                          isInvalid: !isNameValid,
                        })}
                        {...inputActions}
                      />
                    }
                    helperText={
                      <>
                        <div className="d-flex flex-row justify-content-between">
                          <div>
                            {isVerifying && (
                              <div className="text-info">Validating...</div>
                            )}
                            {!isVerifying &&
                              actions.isTouched("event_name") &&
                              !isNull(isNameValid) &&
                              !isNameValid && (
                                <div className="text-danger">
                                  {isEmpty(this.state.values["event_name"])
                                    ? "Event name cannot be empty"
                                    : "Event name already exists"}
                                </div>
                              )}
                          </div>
                        </div>
                      </>
                    }
                  />
                  <FormItem
                    className="mt-0"
                    name={"description"}
                    inputProps={{
                      name: "description",
                      value: this.state.values["description"],
                      rows: 10,
                      style: { borderColor: RESERVATION_COLOR },
                    }}
                    icon
                    placeholder="Write a short description of your event. Include what guests can expect, the general atmosphere, and any key details. (E.g. A relaxed rooftop evening featuring handcrafted cocktails, light bites, and live jazz. Perfect for a casual night out with friends.)"
                    inputActions={inputActions}
                    actions={actions}
                    type={"textarea"}
                    showRequired={true}
                    useTouchedValidation={false}
                    normal
                    noLabel
                  />
                </div>
                <div className="d-flex flex-row align-items-center  mb-4">
                  <h5 className="font-weight-bolder mb-0 mr-2">
                    Do you require dress code?
                  </h5>
                  <span className="switch switch-outline switch-icon switch-info switch-md">
                    <div className="d-flex flex-row justify-content-center">
                      <label className="mb-0">
                        <input
                          type="checkbox"
                          name="dress_code"
                          checked={
                            !isEmpty(this.state.values.dress_code)
                              ? "checked"
                              : null
                          }
                          onChange={(e) => {
                            if (!isEmpty(this.state.values.dress_code)) {
                              this.onDressCodeChange(e);
                            } else {
                              this.changeModalVisible(
                                "dressCodeModal",
                                !this.state.values.dressCodeModal,
                              );
                            }
                          }}
                        />
                        <span></span>
                      </label>
                    </div>
                  </span>
                </div>
                {!isEmpty(this.state.values.dress_code) && (
                  <div className="d-flex flex-column">
                    <div className="d-flex flex-row mb-4">
                      <h5 className="font-weight-bolder mb-0 mr-2">
                        Dress Code
                      </h5>
                      <i
                        className="fas fa-edit"
                        style={{
                          fontSize: "18px",
                          color: RESERVATION_COLOR,
                        }}
                        onClick={() => {
                          this.changeModalVisible("dressCodeModal", true);
                        }}
                      />
                    </div>
                    <div className="d-flex flex-row mb-2">
                      <i
                        className="fas fa-check mr-2"
                        style={{
                          fontSize: "18px",
                          color: "#464e5f",
                        }}
                      />
                      <p>{this.state.values.dress_code}</p>
                    </div>
                  </div>
                )}
                <div className="mb-4">
                  <h5 className="font-weight-bolder mb-3">Ticket Types</h5>

                  {/* Standard Ticket */}
                  {isEmpty(this.state.values.tickets) && (
                    <div className="tickets-empty-container w-100 ">
                      <div className="d-flex flex-column justify-content-center align-items-center h-100">
                        <h5 className="mb-0">
                          Looks like you haven’t added any ticket types yet
                        </h5>
                        <span className="svg-icon svg-icon-dark">
                          <SVG
                            fill="#8A8A8A"
                            style={{ width: 110, height: 110 }}
                            src={toAbsoluteUrl(
                              "/media/svg/events/events_ticket.svg",
                            )}
                          />
                        </span>

                        <span>
                          This ticket type hasn’t been customized yet. <br></br>
                          <KTLink
                            style={{
                              color: RESERVATION_COLOR,
                              paddingTop: 0,
                              paddingBottom: 1,
                            }}
                            text={<>Click here </>}
                            onClick={this.handleHighlightForm}
                          />{" "}
                          to add a name, price, and details
                        </span>
                      </div>
                    </div>
                  )}
                  {!isEmpty(this.state.values.tickets) && (
                    <div>
                      {this.state.values.tickets.map((tier, idx) => {
                        return (
                          !tier.isAdded && (
                            <div
                              key={`ticket-type-${idx}`}
                              className="ticket-tier-container-lg mb-6"
                            >
                              <div className="d-flex flex-column p-6">
                                <div className="d-flex flex-row justify-content-space-between">
                                  <div className="d-flex flex-column justify-content-start align-items-center">
                                    <h6 className="mb-0">
                                      {this.formatTicketString(tier)}
                                    </h6>
                                  </div>
                                  <div className="d-flex flex-column justify-content-end">
                                    <span className="text-muted">
                                      Qty: {tier.capacity}
                                    </span>
                                  </div>
                                </div>
                                <div className="d-flex flex-row font-xs pt-2">
                                  {tier.description}
                                </div>
                              </div>
                            </div>
                          )
                        );
                      })}
                    </div>
                  )}
                </div>
                <h5 className=" font-weight-bolder">Cancellation Policy</h5>
                <FormItem
                  className="mt-0"
                  name={"cancellation_policy"}
                  inputProps={{
                    name: "cancellation_policy",
                    value: this.state.values["cancellation_policy"],
                    rows: 5,
                  }}
                  placeholder={`Add your cancellation policy here (e.g. "Cancellations must be made at least 48 hours before the event to receive a refund. No-shows or late cancellations are non-refundable.")`}
                  inputActions={inputActions}
                  actions={actions}
                  type={"textarea"}
                  showRequired={true}
                  normal
                  noLabel
                  event
                />
              </Card.Body>
            </Card>
          </Col>

          <Col sm={4}>
            <Card className="card-custom mb-4">
              <Card.Body className="px-8">
                <div
                  className="d-flex flex-row justify-content-between align-items-center p-4"
                  style={{
                    // to be move on class "events-sticky-header"
                    position: "sticky",
                    top: 65,
                    backgroundColor: "white",
                    zIndex: 10,
                  }}
                >
                  <h6
                    className="font-weight-bolder mb-0 cursor-pointer"
                    disabled={true}
                    onClick={onPreviewClick}
                  >
                    Preview
                  </h6>{" "}
                  <Button
                    variant="info"
                    onClick={() => {
                      if (isSubmitting || isEmpty(values.tickets)) return;
                      this.formRef.current?.requestSubmit?.();
                    }}
                    className="font-weight-bolder mb-0 cursor-pointer"
                    disabled={
                      !hasUnsavedChanges ||
                      isEventEnded ||
                      isSubmitting ||
                      isVerifying ||
                      !isNameValid ||
                      !isEventDateValid ||
                      !isEventTimeValid ||
                      !isDescriptionValid ||
                      isEmpty(values.image_url) ||
                      isEmpty(values.tickets)
                    }
                  >
                    <div className="d-flex align-items-center">
                      {isSubmitting ? (
                        <>
                          Saving...
                          <span className="spinner spinner-sm spinner-info ml-2"></span>
                        </>
                      ) : (
                        "Save Changes "
                      )}
                    </div>
                  </Button>
                </div>
                <div className="p-4">
                  <div className="d-flex flex-row justify-content-between align-items-top mb-4">
                    <div className="d-flex flex-column flex-grow-1">
                      <h4 className="font-weight-bolder mb-4">
                        Event Visibility{" "}
                        <span className="text-info font-weight-boldest text-uppercase font-size-sm">
                          {this.state.values.status}
                        </span>
                      </h4>
                      <p className="text-muted mb-0">
                        Choose whether your event will be visible to the public
                        or limited to invited guests only
                      </p>
                    </div>
                    <span className="switch switch-outline switch-icon switch-info switch-md">
                      <div className="d-flex flex-row justify-content-center">
                        <label className="mb-0">
                          <input
                            type="checkbox"
                            name="status"
                            checked={
                              this.state.values.status === "public"
                                ? "checked"
                                : null
                            }
                            onChange={this.onStatusChange}
                          />
                          <span></span>
                        </label>
                      </div>
                    </span>
                  </div>
                  {this.props.isEdit &&
                    localStorage.getItem("FF_EVENT_PROMOTION") === "1" && (
                      <div className="d-flex flex-row justify-content-between align-items-top mb-4">
                        <div className="d-flex flex-column flex-grow-1">
                          <h4 className="font-weight-bolder mb-4">
                            Promote event{" "}
                          </h4>
                          <p className="text-muted mb-0">
                            Allow event details to be promoted exclusively on
                            Pickup's Marketplace App, increasing visibility and
                            reach
                          </p>
                        </div>
                        <span className="switch switch-outline switch-icon switch-info switch-md">
                          <div className="d-flex flex-row justify-content-center">
                            <label className="mb-0">
                              <input
                                type="checkbox"
                                name="promote"
                                checked={this.state.values.promote}
                                onChange={this.onPromoteStatusChange}
                              />
                              <span></span>
                            </label>
                          </div>
                        </span>
                      </div>
                    )}

                  <Accordion defaultActiveKey="1">
                    <div
                      onClick={() => {
                        this.toggleAccordion("0");
                      }}
                      className="d-flex justify-content-between align-items-center"
                    >
                      <h4 className="font-weight-bolder ">Event Duration</h4>
                      <i
                        style={{ color: RESERVATION_COLOR }}
                        className={`mb-2 fas fa-chevron-${
                          eventDurationToggle ? "up" : "down"
                        }`}
                      ></i>
                    </div>
                    <Accordion.Collapse eventKey="0" in={eventDurationToggle}>
                      <>
                        <div className="d-flex flex-row align-items-center mb-4">
                          <p className="font-weight-bolder mb-0 mr-2">
                            Is this a one-day event?
                          </p>
                          <FormControlLabel
                            className="mb-0"
                            control={
                              <Checkbox
                                checked={isOneDayEvent}
                                onClick={(event) => {
                                  const isChecked = event.target.checked;
                                  const { values } = this.state;
                                  values["end_date"] = isChecked
                                    ? values.start_date
                                    : values.end_date;

                                  this.setState({
                                    values,
                                    isOneDayEvent: isChecked,
                                  });
                                }}
                                style={{
                                  color: RESERVATION_COLOR,
                                  "&$checked": {
                                    color: RESERVATION_COLOR,
                                  },
                                }}
                                name="oneDayEvent"
                                color="primary"
                              />
                            }
                            label="Yes"
                          />
                        </div>
                        <div className="d-flex justify-content-center">
                          <div className="d-flex border border-2 rounded overflow-hidden text-center">
                            <div className="w-50">
                              <div className="text-muted fw-semibold">
                                {isOneDayEvent ? "Date:" : "From:"}
                              </div>

                              <div className="justify-content-center">
                                <DatePicker
                                  value={values["start_date"]}
                                  onChange={(time) => {
                                    const { values, isOneDayEvent } =
                                      this.state;
                                    const newStartDate = new Date(time);

                                    values["start_date"] = newStartDate;

                                    // If it's a one-day event OR start date is after end date, update end_date
                                    if (
                                      isOneDayEvent ||
                                      moment(newStartDate).isAfter(
                                        moment(values["end_date"]),
                                        "day",
                                      )
                                    ) {
                                      values["end_date"] = newStartDate;
                                    }

                                    const isEventDateValid = moment(
                                      newStartDate,
                                    ).isSameOrBefore(
                                      moment(values["end_date"]),
                                      "day",
                                    );

                                    this.setState({ values, isEventDateValid });
                                  }}
                                  mapDays={({
                                    date,
                                    selectedDate,
                                    currentMonth,
                                    isSameDate,
                                  }) => {
                                    if (date < moment().add(-1, "d")) {
                                      return {
                                        disabled: true,
                                        style: {
                                          color: "#ccc", // gray out
                                          cursor: "not-allowed",
                                        },
                                      };
                                    }

                                    let style = {};
                                    let className = "";

                                    if (
                                      selectedDate &&
                                      isSameDate(date, selectedDate)
                                    ) {
                                      style = {
                                        backgroundColor: RESERVATION_COLOR,
                                        color: "white",
                                        borderRadius: "50%",
                                      };
                                    }

                                    // Disable or style days outside the current month
                                    if (
                                      date.month.number !== currentMonth.number
                                    ) {
                                      style.color = RESERVATION_COLOR;
                                    }

                                    return { className, style };
                                  }}
                                  format="MMM DD, YYYY"
                                  style={{
                                    backgroundColor: "transparent",
                                    borderWidth: 0,
                                    fontSize: 15,
                                    height: 40,
                                    lineHeight: "40px",
                                    textAlign: "center",
                                  }}
                                />
                              </div>
                            </div>

                            {!isOneDayEvent && (
                              <>
                                <div
                                  className="border-start"
                                  style={{
                                    width: "2px",
                                    backgroundColor: "#dee2e6",
                                  }}
                                />
                                <div className="w-50">
                                  <div className="text-muted fw-semibold">
                                    To:
                                  </div>
                                  <div className="justify-content-center">
                                    <DatePicker
                                      value={values["end_date"]}
                                      onChange={(time) => {
                                        const { values } = this.state;
                                        const newEndDate = new Date(time);
                                        values["end_date"] = newEndDate;
                                        const isEventDateValid = moment(
                                          newEndDate,
                                        ).isSameOrAfter(
                                          moment(values["start_date"]),
                                          "day",
                                        );

                                        this.setState({
                                          values,
                                          isEventDateValid,
                                        });
                                      }}
                                      mapDays={({
                                        date,
                                        selectedDate,
                                        currentMonth,
                                        isSameDate,
                                      }) => {
                                        if (
                                          date < new Date() ||
                                          date < new Date(values["start_date"])
                                        ) {
                                          return {
                                            disabled: true,
                                            style: {
                                              color: "#ccc", // gray out
                                              cursor: "not-allowed",
                                            },
                                          };
                                        }

                                        // Customize day styles
                                        let style = {};
                                        let className = "";

                                        // Change color for selected days
                                        if (
                                          selectedDate &&
                                          isSameDate(date, selectedDate)
                                        ) {
                                          style = {
                                            backgroundColor: RESERVATION_COLOR,
                                            color: "white",
                                            borderRadius: "50%",
                                          };
                                        }

                                        // Disable or style days outside the current month
                                        if (
                                          date.month.number !==
                                          currentMonth.number
                                        ) {
                                          style.color = RESERVATION_COLOR;
                                        }

                                        return { className, style };
                                      }}
                                      format="MMM DD, YYYY"
                                      style={{
                                        backgroundColor: "transparent",
                                        borderWidth: 0,
                                        fontSize: 15,
                                        height: 40,
                                        lineHeight: "40px",
                                        textAlign: "center",
                                      }}
                                    />
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                        </div>

                        <div className="mt-3 mb-3">
                          <span className="text-muted">
                            Your event will run for:{" "}
                            {(() => {
                              const days = getDayDifference(
                                values.start_date,
                                values.end_date,
                                values.available_days,
                                values.blockout_dates,
                              );
                              return `${days} day${days > 1 ? "s" : ""}`;
                            })()}
                          </span>
                        </div>

                        {!isOneDayEvent && (
                          <>
                            <div className="d-flex flex-column mb-4">
                              <p className="font-weight-bold mb-0">
                                Event frequency
                              </p>
                              <p className="text-muted mb-0">
                                How often does this event occur?
                              </p>
                              <div className="mt-2">
                                <div className="d-flex flex-column">
                                  <FormControlLabel
                                    className="mb-0"
                                    control={
                                      <Radio
                                        checked={eventFrequency === "daily"}
                                        onChange={() => {
                                          const { values } = this.state;
                                          values.available_days = [
                                            0, 1, 2, 3, 4, 5, 6,
                                          ];
                                          this.setState({
                                            values,
                                            eventFrequency: "daily",
                                          });
                                        }}
                                        value="daily"
                                        name="radio-buttons-group"
                                        style={{
                                          paddingTop: 3,
                                          paddingBottom: 3,
                                          color: RESERVATION_COLOR, // Color when unchecked
                                          "&.Mui-checked": {
                                            color: RESERVATION_COLOR, // Custom purple color when checked
                                          },
                                        }}
                                      />
                                    }
                                    label="Daily"
                                  />
                                  <FormControlLabel
                                    className="mb-0"
                                    control={
                                      <Radio
                                        checked={
                                          eventFrequency === "selectedDays"
                                        }
                                        onChange={() => {
                                          const { values } = this.state;
                                          values.available_days = [0, 2, 4, 6];
                                          this.setState({
                                            values,
                                            eventFrequency: "selectedDays",
                                          });
                                        }}
                                        value="selectedDays"
                                        name="radio-buttons-group"
                                        style={{
                                          paddingTop: 3,
                                          paddingBottom: 3,
                                          color: RESERVATION_COLOR, // Color when unchecked
                                          "&.Mui-checked": {
                                            color: RESERVATION_COLOR, // Custom purple color when checked
                                          },
                                        }}
                                      />
                                    }
                                    label="On selected days"
                                  />
                                </div>
                              </div>
                            </div>
                            {eventFrequency === "selectedDays" && (
                              <div className="d-flex flex-column mb-4">
                                <p className="font-weight-bold text-center mb-0">
                                  Which days of the week will your event run?
                                </p>
                                <div className="d-flex flex-column flex-grow-1 mt-1">
                                  <Grid item>
                                    <ButtonGroup
                                      size="small"
                                      variant="contained"
                                      className="d-flex w-100"
                                      style={{
                                        boxShadow: "none",
                                        justifyContent: "center",
                                      }}
                                    >
                                      {[
                                        "M",
                                        "T",
                                        "W",
                                        "TH",
                                        "F",
                                        "S",
                                        "SU",
                                      ].map((day, index) => (
                                        <Button
                                          style={{
                                            minWidth: KTUtil.isMobileDevice()
                                              ? 45
                                              : "unset",
                                            minHeight: KTUtil.isMobileDevice()
                                              ? 60
                                              : "unset",
                                            padding: "0.6rem 0.8rem",
                                          }}
                                          variant={
                                            values.available_days.includes(
                                              index,
                                            )
                                              ? "info"
                                              : "outline"
                                          }
                                          key={`${day}-btn`}
                                          onClick={(e) =>
                                            this.handleDayClick(index, e)
                                          }
                                        >
                                          {day}
                                        </Button>
                                      ))}
                                    </ButtonGroup>
                                  </Grid>
                                  <div className="text-center align-center pt-2 text-muted">
                                    {getAvailabilityMessage(
                                      values.available_days,
                                    )}
                                  </div>
                                </div>
                              </div>
                            )}
                          </>
                        )}
                      </>
                    </Accordion.Collapse>
                    <div
                      onClick={() => {
                        this.toggleAccordion("5");
                      }}
                      className="d-flex justify-content-between align-items-center mt-2"
                    >
                      <h4 className="font-weight-bolder">
                        {" "}
                        Blockout Date & Time?
                      </h4>
                      <i
                        style={{ color: RESERVATION_COLOR }}
                        className={`mb-2 fas fa-chevron-${
                          BlockOutDatesToggle ? "up" : "down"
                        }`}
                      ></i>
                    </div>
                    <Accordion.Collapse eventKey="2" in={BlockOutDatesToggle}>
                      <>
                        <div className="d-flex flex-column mb-2">
                          <div className="d-flex flex-column flex-grow-1">
                            <div className="d-flex mt-auto pt-2 text-muted">
                              {`Use this to block off specific dates when your event won't be offered (e.g like rest days or venue conflicts)`}
                            </div>
                          </div>
                          {this.state.values.blockout_dates.length > 0 && (
                            <div className="mt-3">
                              <ul className="list-group">
                                {this.state.values.blockout_dates.map(
                                  (date, index) => (
                                    <li
                                      key={`blocked-dated-${index}`}
                                      className="list-group-item d-flex justify-content-between align-items-center"
                                    >
                                      {date}
                                      <button
                                        type="button"
                                        className="btn btn-sm btn-danger"
                                        onClick={() => {
                                          const blockoutDates =
                                            this.state.values.blockout_dates.filter(
                                              (d) => d !== date,
                                            );
                                          this.setState({
                                            values: {
                                              ...this.state.values,
                                              blockout_dates: blockoutDates,
                                            },
                                          });
                                        }}
                                      >
                                        Remove
                                      </button>
                                    </li>
                                  ),
                                )}
                              </ul>
                            </div>
                          )}

                          <KTLink
                            style={{
                              color: RESERVATION_COLOR,
                              textAlign: "end",
                              textDecoration: "underline",
                            }}
                            text={<>+ Add Blockout Dates</>}
                            onClick={() =>
                              this.changeModalVisible(
                                "blockoutDatesModal",
                                true,
                              )
                            }
                          />
                        </div>
                      </>
                    </Accordion.Collapse>
                    <div
                      onClick={() => {
                        this.toggleAccordion("1");
                      }}
                      className="d-flex justify-content-between align-items-center mt-2"
                    >
                      <h4 className="font-weight-bolder">Event Time Options</h4>
                      <i
                        style={{ color: RESERVATION_COLOR }}
                        className={`mb-2 fas fa-chevron-${
                          eventTimeOptionsToggle ? "up" : "down"
                        }`}
                      ></i>
                    </div>
                    <Accordion.Collapse
                      eventKey="1"
                      in={eventTimeOptionsToggle}
                    >
                      <>
                        <p className="text-muted mb-2">
                          Set the start and end times for your event. You can
                          add multiple time slots if your event runs more than
                          once per day.
                        </p>
                        <div className="mt-4 mb-3">
                          <>
                            <>
                              {this.state.values.time_slots.map(
                                (time_slot, index) => {
                                  // safely parse the time strings into Date objects
                                  const startTimeMoment = time_slot.start_time
                                    ? moment(
                                        new Date(time_slot.start_time),
                                        "HH:mm",
                                      )
                                    : null;

                                  const endTimeMoment = time_slot.end_time
                                    ? moment(
                                        new Date(time_slot.end_time),
                                        "HH:mm",
                                      )
                                    : null;

                                  return (
                                    <div
                                      key={`time-slot-${index}`}
                                      style={{ position: "relative" }}
                                    >
                                      <div className="d-flex justify-content-between align-items-center mb-2 mt-2 fw-bold fs-5">
                                        <div>Timeslot {index + 1}:</div>
                                        <div className="d-flex gap-2"></div>
                                      </div>
                                      <div className="d-flex border rounded overflow-hidden">
                                        {/* Start Time */}
                                        <div className="py-2 px-3 w-50">
                                          <div className="text-muted fw-semibold">
                                            Start:
                                          </div>
                                          <div className="d-flex justify-content-center">
                                            <DatePicker
                                              inputClass={`form-control p-0 font-weight-bolder ${
                                                !time_slot.isStartValid
                                                  ? "is-invalid"
                                                  : ""
                                              }`}
                                              disableDayPicker
                                              value={
                                                startTimeMoment?.toDate() ||
                                                null
                                              }
                                              format="hh:mm A"
                                              plugins={[
                                                <TimePicker hideSeconds />,
                                              ]}
                                              onChange={(time) => {
                                                const { values } = this.state;
                                                const newMoment = moment(
                                                  new Date(time),
                                                );
                                                values.time_slots[
                                                  index
                                                ].start_time =
                                                  newMoment.isValid()
                                                    ? newMoment
                                                    : "";
                                                // Check time validity
                                                const startTime = moment(
                                                  newMoment.format("HH:mm"),
                                                  "HH:mm",
                                                ).format("HH");
                                                const endTime = moment(
                                                  values.time_slots[index]
                                                    .end_time,
                                                  "HH:mm",
                                                ).format("HH");

                                                const is_start_valid =
                                                  startTime < endTime;

                                                const duplicate_start_time =
                                                  values.tickets.findIndex(
                                                    (time, idx) =>
                                                      idx !== index &&
                                                      time.start_time ===
                                                        moment(
                                                          newMoment,
                                                        ).format("HH:mm"),
                                                  ) > -1;

                                                values.time_slots[
                                                  index
                                                ].isStartValid =
                                                  !duplicate_start_time &&
                                                  is_start_valid;
                                                values.time_slots[
                                                  index
                                                ].isEndValid = is_start_valid;
                                                values.time_slots[
                                                  index
                                                ].isTouched = true;

                                                this.setState({
                                                  values,
                                                  isEventTimeValid:
                                                    !duplicate_start_time ||
                                                    is_start_valid,
                                                });
                                              }}
                                              style={{
                                                backgroundColor: "transparent",
                                                borderWidth: 0,
                                                fontSize: 13,
                                                height: "unset",
                                                // lineHeight: "40px",
                                                textAlign: "center",
                                              }}
                                            />
                                          </div>
                                        </div>

                                        <div
                                          style={{
                                            width: "1px",
                                            backgroundColor: "#dee2e6",
                                          }}
                                        />

                                        {/* End Time */}
                                        <div className="py-2 px-3 w-50">
                                          <div className="text-muted fw-semibold">
                                            End:
                                          </div>
                                          <div className="d-flex justify-content-center">
                                            <DatePicker
                                              inputClass={`form-control p-0 font-weight-bolder ${
                                                !time_slot.isEndValid
                                                  ? "is-invalid"
                                                  : ""
                                              }`}
                                              disableDayPicker
                                              value={
                                                endTimeMoment?.toDate() || null
                                              }
                                              format="hh:mm A"
                                              plugins={[
                                                <TimePicker hideSeconds />,
                                              ]}
                                              onChange={(time) => {
                                                const { values } = this.state;
                                                const newMoment = moment(
                                                  new Date(time),
                                                );
                                                values.time_slots[
                                                  index
                                                ].end_time = newMoment.isValid()
                                                  ? newMoment
                                                  : "";
                                                // Check time validity

                                                const startTime = moment(
                                                  values.time_slots[index]
                                                    .start_time,
                                                  "HH:mm",
                                                ).format("HH");
                                                const endTime = moment(
                                                  newMoment.format("HH:mm"),
                                                  "HH:mm",
                                                ).format("HH");

                                                const is_end_valid =
                                                  endTime > startTime;

                                                values.time_slots[
                                                  index
                                                ].isStartValid = is_end_valid;
                                                values.time_slots[
                                                  index
                                                ].isEndValid = is_end_valid;

                                                values.time_slots[
                                                  index
                                                ].isTouched = true;

                                                this.setState({
                                                  values,
                                                  isEventTimeValid:
                                                    is_end_valid,
                                                });
                                              }}
                                              style={{
                                                backgroundColor: "transparent",
                                                borderWidth: 0,
                                                fontSize: 13,
                                                height: "unset",
                                                // lineHeight: "40px",
                                                textAlign: "center",
                                              }}
                                            />
                                          </div>
                                          {index > 0 && (
                                            <Button
                                              variant="danger"
                                              className="d-flex align-items-center justify-content-center"
                                              onClick={() => {
                                                this.removeTimeSlots(index);
                                              }}
                                              style={{
                                                width: 25,
                                                height: 25,
                                                borderRadius: 100,
                                                position: "absolute",
                                                top: "3vh",
                                                right: 0,
                                              }}
                                            >
                                              <i
                                                className="fas fa-trash ml-1"
                                                style={{ fontSize: "1rem" }}
                                              />
                                            </Button>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  );
                                },
                              )}
                            </>

                            <div
                              className="events-add-slot-box mt-3 mb-3 text-center cursor-pointer"
                              onClick={() => {
                                if (isEventEnded) {
                                  MySwal.fire({
                                    icon: "info",
                                    title: "Event has ended",
                                    text: "You cannot add a new timeslot to a past event.",
                                    confirmButtonColor: RESERVATION_COLOR,
                                  });
                                  return;
                                }
                                this.addTimeSlotCount();
                              }}
                            >
                              <Button
                                variant="info-outline"
                                className="rounded-circle events-plus-button"
                              >
                                +
                              </Button>
                            </div>
                          </>
                        </div>
                      </>
                    </Accordion.Collapse>
                    <div id="event-ticket-form">
                      <div
                        onClick={() => {
                          this.toggleAccordion("2");
                        }}
                        className="d-flex justify-content-between align-items-center mt-6"
                      >
                        <h4 className="font-weight-bolder">
                          Ticket Types & Pricing
                        </h4>
                        <i
                          style={{ color: RESERVATION_COLOR }}
                          className={`mb-2 fas fa-chevron-${
                            eventTicketsToggle ? "up" : "down"
                          }`}
                        ></i>
                      </div>
                      <Accordion.Collapse eventKey="2" in={eventTicketsToggle}>
                        <>
                          <p className="text-muted mb-2">
                            List your ticket types, pricing, and capacity per
                            ticket.
                          </p>
                          <div className="mt-4">
                            <>
                              <>
                                {this.state.values.tierGroup.map(
                                  (tier, tier_idx) => {
                                    return tier.isEdit ? (
                                      <div key={`ticket-edit-${tier_idx}`}>
                                        <div className="d-flex justify-content-between align-items-center mb-2 mt-2 fw-bold fs-5">
                                          <div className="font-size-lg font-weight-bolder">
                                            Ticket {tier_idx + 1}:
                                          </div>
                                          <div className="d-flex gap-2"></div>
                                        </div>
                                        <FormItem
                                          label="Name"
                                          name="name"
                                          className={"form-control-solid"}
                                          maxLength={50}
                                          placeholder="What would you call this ticket type?"
                                          inputProps={{
                                            value: tier.name,
                                            name: `tier_name-${tier_idx}`,
                                            onChange: (e) => {
                                              const { values } = this.state;
                                              values.tierGroup[tier_idx].name =
                                                e.target.value;
                                              values.tierGroup[
                                                tier_idx
                                              ].isTouched = true;
                                              this.setState({ values });
                                            },
                                          }}
                                          event
                                          normal
                                          actions={actions}
                                        />
                                        <FormItem
                                          event
                                          name={"description"}
                                          label={"Description"}
                                          maxLength={300}
                                          inputProps={{
                                            name: `tier_description-${tier_idx}`,
                                            placeholder: `Provide a short description of what this ticket offers. Include access level, amenities, or restrictions`,
                                            value: tier.description,
                                            onChange: (e) => {
                                              const { values } = this.state;
                                              values.tierGroup[
                                                tier_idx
                                              ].description = e.target.value;
                                              values.tierGroup[
                                                tier_idx
                                              ].isTouched = true;
                                              this.setState({ values });
                                            },
                                            rows: 4,
                                          }}
                                          actions={actions}
                                          type={"textarea"}
                                          normal
                                        />

                                        <FormItem
                                          className={"form-control-solid"}
                                          label="Price"
                                          name="price"
                                          placeholder="Php 100.00"
                                          value={tier.price}
                                          type="number"
                                          inputProps={{
                                            name: `tier_price-${tier_idx}`,
                                            value: tier.price,
                                            onChange: (e) => {
                                              const { values } = this.state;
                                              values.tierGroup[tier_idx].price =
                                                e.target.value;
                                              values.tierGroup[
                                                tier_idx
                                              ].isTouched = true;
                                              this.setState({ values });
                                            },
                                          }}
                                          event
                                          actions={actions}
                                          normal
                                        />

                                        <FormItem
                                          event
                                          className={"form-control-solid"}
                                          label={
                                            <div className="w-100 d-flex flex-row align-items-center">
                                              <Label
                                                text="Quantity"
                                                className="w-100 mb-0 d-flex"
                                              />
                                              <div
                                                className="text-muted"
                                                style={{
                                                  fontSize: "0.8rem",
                                                  fontWeight: 400,
                                                }}
                                              >
                                                <span>
                                                  &nbsp;(this will set the limit
                                                  to the number of tickets
                                                  offered)
                                                </span>
                                              </div>
                                            </div>
                                          }
                                          name="capacity"
                                          placeholder="50"
                                          value={tier.capacity}
                                          type="number"
                                          inputProps={{
                                            name: `tier_capacity-${tier_idx}`,
                                            value: tier.capacity,
                                            onChange: (e) => {
                                              const { values } = this.state;
                                              values.tierGroup[
                                                tier_idx
                                              ].capacity = e.target.value;
                                              values.tierGroup[
                                                tier_idx
                                              ].isTouched = true;
                                              this.setState({ values });
                                            },
                                          }}
                                          actions={actions}
                                          normal
                                        />
                                        {this.state.values.time_slots.length >
                                          0 && (
                                          <div className="d-flex w-100 flex-column">
                                            <p className="font-bolder mb-2">
                                              Set When This Ticket Is Available
                                            </p>
                                            {this.state.values.time_slots.map(
                                              (
                                                {
                                                  start_time,
                                                  end_time,
                                                  _id = "",
                                                },
                                                time_idx,
                                              ) => {
                                                const isChecked = this.props
                                                  .isEdit
                                                  ? tier.time_slots.filter(
                                                      (t) => t._id === _id,
                                                    ).length === 1
                                                  : tier.time_slots.indexOf(
                                                      time_idx,
                                                    ) >= 0;

                                                return (
                                                  <div
                                                    key={`ticket-time-${time_idx}`}
                                                    className="w-100 py-1"
                                                  >
                                                    <Button
                                                      type="button"
                                                      variant="outline-primary"
                                                      style={{
                                                        borderColor: isChecked
                                                          ? RESERVATION_COLOR
                                                          : "#B5B5C3",
                                                        color: isChecked
                                                          ? RESERVATION_COLOR
                                                          : "#B5B5C3",
                                                        borderRadius: 25,
                                                        backgroundColor:
                                                          "#ffff",
                                                      }}
                                                      className="btn btn-outline-pickup w-100 text-left d-flex flex-row"
                                                    >
                                                      <label
                                                        className={`top-0 checkbox checkbox-outline checkbox-circle checkbox-${
                                                          isChecked
                                                            ? "info"
                                                            : "light"
                                                        }`}
                                                      >
                                                        <input
                                                          type="checkbox"
                                                          checked={isChecked}
                                                          onChange={() =>
                                                            this.onAddTimeSlot(
                                                              tier_idx,
                                                              this.props.isEdit
                                                                ? _id
                                                                : time_idx,
                                                              isChecked,
                                                            )
                                                          }
                                                        />
                                                        <span />
                                                      </label>
                                                      Timeslot {time_idx + 1} (
                                                      {moment(
                                                        new Date(start_time),
                                                      ).format("hh:mm")}
                                                      {" - "}
                                                      {moment(
                                                        new Date(end_time),
                                                      ).format("hh:mm A")}
                                                      )
                                                    </Button>
                                                  </div>
                                                );
                                              },
                                            )}
                                          </div>
                                        )}
                                        <Button
                                          type="button"
                                          variant="info"
                                          style={{
                                            color: "#fff",
                                            borderRadius: 25,
                                          }}
                                          disabled={
                                            this.state.values.tierGroup[
                                              tier_idx
                                            ].name.trim() === "" ||
                                            this.state.values.tierGroup[
                                              tier_idx
                                            ].price === "" ||
                                            this.state.values.tierGroup[
                                              tier_idx
                                            ].capacity === "" ||
                                            this.state.values.tierGroup[
                                              tier_idx
                                            ].time_slots.length === 0
                                          }
                                          className="btn font-weight-bold w-100 my-4"
                                          onClick={() => {
                                            this.onSaveTicketType(tier_idx);
                                          }}
                                        >
                                          Save Ticket Details
                                        </Button>
                                      </div>
                                    ) : (
                                      <div>
                                        <div
                                          key={`ticket-${tier_idx}`}
                                          className="ticket-tier-container-sm"
                                        >
                                          <div className="d-flex flex-row h-100">
                                            <div
                                              className="d-flex flex-column align-items-center justify-content-center"
                                              style={{ flexBasis: "60%" }}
                                            >
                                              <div className="d-flex flex-row">
                                                <h6>
                                                  {this.formatTicketString(
                                                    tier,
                                                  )}
                                                </h6>
                                              </div>

                                              {tier.time_slots.length && (
                                                <div className="d-flex flex-row flex-wrap justify-content-center">
                                                  {tier.time_slots.map(
                                                    (slot, i) => {
                                                      let moment_start = "";
                                                      let moment_end = "";
                                                      const time_slot_arr =
                                                        this.state.values
                                                          .time_slots;

                                                      if (
                                                        slot &&
                                                        this.props.isEdit
                                                      ) {
                                                        moment_start = moment(
                                                          slot.start_time,
                                                        ).format("h:mm");
                                                        moment_end = moment(
                                                          slot.end_time,
                                                        ).format("h:mmA");
                                                      } else if (
                                                        time_slot_arr[i] &&
                                                        !this.props.isEdit
                                                      ) {
                                                        moment_start = moment(
                                                          time_slot_arr[slot]
                                                            .start_time,
                                                        ).format("h:mm");
                                                        moment_end = moment(
                                                          time_slot_arr[slot]
                                                            .end_time,
                                                          slot.end_time,
                                                        ).format("h:mmA");
                                                      }

                                                      return (
                                                        <div
                                                          key={`time-pill-${i}`}
                                                          className={`timeslot-pill ${
                                                            i > 1 ? "mt-1" : ""
                                                          }`}
                                                        >
                                                          {moment_start}-
                                                          {moment_end}
                                                        </div>
                                                      );
                                                    },
                                                  )}
                                                </div>
                                              )}
                                            </div>
                                            <div
                                              className="d-flex flex-column align-items-center justify-content-center"
                                              style={{ flexBasis: "40%" }}
                                            >
                                              <div className="d-flex flex-row">
                                                <h6 className="mr-4 mb-0">
                                                  Qty: {tier.capacity}
                                                </h6>
                                                <i
                                                  className="far fa-edit mr-2 cursor-pointer"
                                                  style={{
                                                    color: RESERVATION_COLOR,
                                                  }}
                                                  onClick={() =>
                                                    this.onEditTicket(tier_idx)
                                                  }
                                                />
                                                <i
                                                  className="far fa-trash-alt text-danger cursor-pointer"
                                                  onClick={() =>
                                                    this.onRemoveTicket(
                                                      tier_idx,
                                                    )
                                                  }
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  },
                                )}
                                {!this.state.values.tierGroup.some(
                                  (tier) => tier.isEdit,
                                ) && (
                                  <div
                                    className="events-add-slot-box mt-3 mb-3 text-center cursor-pointer w-100 d-flex flex-row justify-content-center"
                                    onClick={async (e) => {
                                      e.preventDefault();
                                      if (isEventEnded) {
                                        MySwal.fire({
                                          icon: "info",
                                          title: "Event has ended",
                                          text: "You cannot add a new ticket type to a past event.",
                                          confirmButtonColor: RESERVATION_COLOR,
                                        });
                                        return;
                                      }
                                      if (
                                        this.state.values.time_slots.length ===
                                        0
                                      ) {
                                        MySwal.fire({
                                          icon: "info",
                                          title: "No Time Slots",
                                          text: "Please add at least one time slot before creating a ticket type.",
                                          confirmButtonColor: RESERVATION_COLOR,
                                        });
                                        return;
                                      }
                                      await this.addTier();
                                    }}
                                  >
                                    <Button
                                      variant="info-outline"
                                      className="p-0 mr-2"
                                      style={{
                                        color: RESERVATION_COLOR,
                                        width: 20,
                                        height: 20,
                                        fontSize: 12,
                                      }}
                                    >
                                      +
                                    </Button>
                                    <div style={{ color: RESERVATION_COLOR }}>
                                      Add new ticket type
                                    </div>
                                  </div>
                                )}
                              </>
                            </>
                          </div>
                        </>
                      </Accordion.Collapse>
                    </div>
                    <div
                      onClick={() => {
                        this.toggleAccordion("3");
                      }}
                      className="d-flex justify-content-between align-items-center mt-2"
                    >
                      <h4 className="font-weight-bolder mb-2">
                        Event Location
                      </h4>
                      <i
                        style={{ color: RESERVATION_COLOR }}
                        className={`mb-2 fas fa-chevron-${
                          eventLocationToggle ? "up" : "down"
                        }`}
                      ></i>
                    </div>
                    <Accordion.Collapse eventKey="3" in={eventLocationToggle}>
                      <MapComponent
                        mapClassName="form-event-control"
                        state={this.state}
                        height="400px"
                        zoom={this.state.values.zoom_value}
                        api={this.api}
                        tooltipDisplay={false}
                        placeholder="Enter event location"
                      />
                    </Accordion.Collapse>
                    <div
                      onClick={() => {
                        this.toggleAccordion("4");
                      }}
                      className="d-flex justify-content-between align-items-center mt-2"
                    >
                      <h4 className="font-weight-bolder mb-2">
                        {" "}
                        Guest List Access
                      </h4>
                      <i
                        style={{ color: RESERVATION_COLOR }}
                        className={`mb-2 fas fa-chevron-${
                          eventGuestListToggle ? "up" : "down"
                        }`}
                      ></i>
                    </div>
                    <Accordion.Collapse eventKey="4" in={eventGuestListToggle}>
                      <>
                        <p className="fs-6 text-muted mb-2">
                          Send complimentary tickets to invited guests. These
                          tickets grant access without requiring payment or
                          public booking.
                        </p>
                        <p className="fs-6 text-muted mb-2">
                          These complimentary tickets are included in your
                          ticket capacity and should be accounted for when
                          setting ticket limits.
                        </p>
                        <br />
                        <div className="d-flex flex-row">
                          <Button
                            type="button"
                            variant="info"
                            onClick={() => {
                              if (isEventEnded) {
                                MySwal.fire({
                                  icon: "info",
                                  title: "Event has ended",
                                  text: "You cannot manage guests for a past event.",
                                  confirmButtonColor: RESERVATION_COLOR,
                                });
                                return;
                              }

                              if (hasUnsavedChanges) {
                                MySwal.fire({
                                  icon: "warning",
                                  title: "Unsaved Changes",
                                  text: "You have unsaved changes. Please save them before managing guests.",
                                  confirmButtonText: "Save Now",
                                  showCancelButton: true,
                                  confirmButtonColor: RESERVATION_COLOR,
                                }).then((result) => {
                                  if (result.isConfirmed) {
                                    this.formRef.current?.requestSubmit?.();
                                  }
                                });
                                return;
                              }
                              const { event } = this.props;

                              if (isEmpty(event)) {
                                MySwal.fire({
                                  icon: "error",
                                  title: "Ooops!",
                                  text: "You need to save the event first before you can manage guests",
                                  confirmButtonColor: RESERVATION_COLOR,
                                  confirmButtonText: "Save Now",
                                  showCancelButton: true,
                                  cancelButtonText: "Cancel",
                                }).then((result) => {
                                  if (result.isConfirmed) {
                                    this.formRef.current?.requestSubmit?.();
                                  }
                                });
                              } else {
                                const { values } = this.state;

                                if (values.tickets < 1) {
                                  MySwal.fire({
                                    icon: "error",
                                    title: "Ooops!",
                                    text: "You need to add atleast one (1) ticket to proceed on managing guestlist",
                                    confirmButtonColor: RESERVATION_COLOR,
                                    confirmButtonText: "Add Now",
                                    showCancelButton: true,
                                    cancelButtonText: "Cancel",
                                  }).then((result) => {
                                    if (result.isConfirmed) {
                                      this.handleHighlightForm();
                                    }
                                  });
                                } else {
                                  this.changeModalVisible(
                                    "guestListModal",
                                    true,
                                  );
                                }
                              }
                            }}
                            className="btn font-weight-bold"
                            style={{
                              color: "#fff",
                            }}
                          >
                            <i className="fas fa-users mr-2"></i>
                            Manage Guest List
                          </Button>
                          <Button
                            type="button"
                            variant="info"
                            onClick={() => {
                              if (isEventEnded) {
                                MySwal.fire({
                                  icon: "info",
                                  title: "Event has ended",
                                  text: "You cannot manage guests for a past event.",
                                  confirmButtonColor: RESERVATION_COLOR,
                                });
                                return;
                              }

                              if (hasUnsavedChanges) {
                                MySwal.fire({
                                  icon: "warning",
                                  title: "Unsaved Changes",
                                  text: "You have unsaved changes. Please save them before generating a link.",
                                  confirmButtonText: "Save Now",
                                  showCancelButton: true,
                                  confirmButtonColor: RESERVATION_COLOR,
                                }).then((result) => {
                                  if (result.isConfirmed) {
                                    this.formRef.current?.requestSubmit?.();
                                  }
                                });
                                return;
                              }
                              const { event } = this.props;
                              if (isEmpty(event)) {
                                MySwal.fire({
                                  icon: "error",
                                  title: "Ooops!",
                                  text: "You need to save the event first before you can manage invite links",
                                  confirmButtonColor: RESERVATION_COLOR,
                                  confirmButtonText: "Save Now",
                                  showCancelButton: true,
                                  cancelButtonText: "Cancel",
                                }).then((result) => {
                                  if (result.isConfirmed) {
                                    this.formRef.current?.requestSubmit?.();
                                  }
                                });
                              } else {
                                this.setState({ showInviteLinkModal: true });
                              }
                            }}
                            className={`btn font-weight-bold ml-3 hover-shadow`}
                            style={{
                              color: "#fff",
                              borderColor: RESERVATION_COLOR,
                            }}
                          >
                            <i className="fas fa-envelope mr-2"></i>
                            Manage Invite Links
                          </Button>
                        </div>
                      </>
                    </Accordion.Collapse>
                  </Accordion>
                </div>
                <div
                  className="d-flex flex-row justify-content-center align-items-center p-4 py-2 "
                  style={{
                    bottom: 0,
                    backgroundColor: "white",
                    zIndex: 10,
                  }}
                >
                  <Button
                    type="button"
                    variant="outline-primary-pickup"
                    className="w-100"
                    onClick={() => {
                      if (isSubmitting || isEmpty(values.tickets)) return;
                      this.formRef.current?.requestSubmit?.();
                    }}
                    style={{
                      color: RESERVATION_COLOR,
                      borderColor: RESERVATION_COLOR,
                    }}
                    disabled={
                      isEventEnded ||
                      !hasUnsavedChanges ||
                      isSubmitting ||
                      isVerifying ||
                      !isNameValid ||
                      !isEventDateValid ||
                      !isEventTimeValid ||
                      !isDescriptionValid ||
                      isEmpty(values.image_url) ||
                      isEmpty(values.tickets)
                    }
                  >
                    {isSubmitting ? (
                      <>
                        Saving...
                        <span className="spinner spinner-sm spinner-info ml-2"></span>
                      </>
                    ) : (
                      <h6 className="mb-0">Save Details</h6>
                    )}
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Modal centered show={this.state.values.dressCodeModal}>
          <Modal.Header closeButton>
            <Modal.Title>Set Dress Code</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {[
              "Casual",
              "Smart Casual",
              "Formal / Black Tie",
              "Cocktail Attire",
              "Semi-Formal",
              "Business Formal",
              "Resort Casual",
            ].map((label, idx) => (
              <button
                key={`dress-code-${idx}`}
                type="button"
                onClick={() => {
                  const { values } = this.state;
                  values.dress_code = label;
                  this.setState({ values });
                }}
                className="btn btn-light rounded-pill mr-4 mb-4"
              >
                {label}
              </button>
            ))}
            <div className="mb-2">
              <label className="mb-0 font-weight-bold">Theme-Based:</label>
              <input
                type="text"
                className="form-control"
                value={this.state.values.dress_code}
                onChange={(e) => {
                  const { values } = this.state;
                  values.dress_code = e.target.value;
                  this.setState({ values });
                }}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div>
              <button
                type="button"
                onClick={() => this.changeModalVisible("dressCodeModal", false)}
                className="btn btn-light btn-elevate"
              >
                Cancel
              </button>
              <> </>
              <button
                type="button"
                onClick={() => this.changeModalVisible("dressCodeModal", false)}
                className="btn btn-delete btn-info btn-elevate"
              >
                Save changes
              </button>
            </div>
          </Modal.Footer>
        </Modal>
        <Modal size="xl" centered show={this.state.values.blockoutDatesModal}>
          <Modal.Header>
            <Modal.Title>Add Blockout Dates</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="events-calendar-wrapper">
              <FullCalendar
                className="events-calendar-content"
                height={500}
                headerToolbar={{
                  start: "",
                  center: "title",
                  end: "prev,next",
                }}
                validRange={{
                  start: isPast(new Date(values["start_date"]))
                    ? new Date()
                    : moment(values["start_date"]).startOf("day").toDate(),
                  end: moment(values["end_date"]).endOf("day").toDate(),
                }}
                showNonCurrentDates={false}
                fixedWeekCount={false}
                selectable={true}
                eventClick={this.handleEventClick}
                selectAllow={this.selectAllow}
                dateClick={this.dateClick}
                dayCellClassNames={this.dayCellClassNames}
                events={[
                  {
                    daysOfWeek: values["available_days"].map(
                      (day) => (day + 1) % 7,
                    ),
                    startRecur: moment(values["start_date"])
                      .startOf("day")
                      .toDate(),
                    endRecur: moment(values["end_date"]).endOf("day").toDate(),
                    display: "background",
                    backgroundColor: "#8950FC",
                  },
                ]}
                // headerToolbar={false}
                ref={this.calendarRef}
                plugins={[dayGridPlugin, interactionPlugin]}
                initialView="dayGridMonth"
                weekends={true}
                eventContent={this.renderEventContent}
              />
              <div className="d-flex justify-content-between align-items-start mt-4">
                {/* Left side: legend */}
                <div>
                  <div className="d-flex align-items-center mb-2">
                    <div
                      className="mr-2"
                      style={{
                        width: "20px",
                        height: "20px",
                        backgroundColor: "#dcccff",
                        borderRadius: "4px",
                      }}
                    ></div>
                    <span>Active Event Date</span>
                  </div>

                  <div className="d-flex align-items-center">
                    <div
                      className="mr-2"
                      style={{
                        width: "20px",
                        height: "20px",
                        backgroundColor: "#fff",
                        border: "1px solid #dee2e6",
                        borderRadius: "4px",
                      }}
                    ></div>
                    <span>No Event Scheduled</span>
                  </div>
                </div>

                {/* Right side: info text */}
                <div className="text-right" style={{ maxWidth: "45%" }}>
                  <p className="mb-2">
                    Click on the calendar to select a date to block out for your
                    event.
                  </p>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div>
              <button
                type="button"
                onClick={() =>
                  this.changeModalVisible("blockoutDatesModal", false)
                }
                className="btn btn-light btn-elevate"
              >
                Cancel
              </button>
              <> </>
              <button
                type="button"
                onClick={() =>
                  this.changeModalVisible("blockoutDatesModal", false)
                }
                className="btn btn-delete btn-info btn-elevate"
              >
                Save changes
              </button>
            </div>
          </Modal.Footer>
        </Modal>
        <Modal
          size="xl"
          centered
          show={this.state.values.guestListModal}
          // show={true}
        >
          <Modal.Header>
            <Modal.Title>{`Manage Guest List`}</Modal.Title>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                this.changeModalVisible("guestListModal", false);
                this.accordionOpen("guestCalendar", true);
                this.accordionOpen("guestSlot", false);
                this.accordionOpen("guestListTable", false);
              }}
            >
              <i aria-hidden="true" className="ki ki-close"></i>
            </button>
          </Modal.Header>

          <div className="d-flex flex-column mr-7 ml-7 mt-3">
            <p className="text-muted mb-0">
              Add your guest list by manually entering details or uploading a
              CSV file. Use the format: first name, last name, email, contact
              number, ticket type, quantity.
            </p>
          </div>
          <Modal.Body>
            <div className="events-calendar-wrapper">
              <Accordion defaultActiveKey="1">
                <Accordion.Collapse
                  eventKey="guestCalendar"
                  in={eventGuestCalendarToggle}
                >
                  <>
                    <FullCalendar
                      className="events-calendar-content"
                      headerToolbar={{
                        start: "",
                        center: "title",
                        end: "prev,next",
                      }}
                      validRange={{
                        start: isPast(new Date(values["start_date"]))
                          ? new Date()
                          : moment(values["start_date"])
                              .startOf("day")
                              .toDate(),
                        end: moment(values["end_date"]).endOf("day").toDate(),
                      }}
                      height={500}
                      showNonCurrentDates={false}
                      fixedWeekCount={false}
                      selectable={true}
                      eventClick={this.handleEventClick}
                      selectAllow={this.selectAllow}
                      dateClick={this.dateClickGuest}
                      dayCellClassNames={this.dayCellClassNames}
                      events={[
                        {
                          daysOfWeek: values["available_days"].map(
                            (day) => (day + 1) % 7,
                          ),
                          startRecur: moment(values["start_date"])
                            .startOf("day")
                            .toDate(),
                          endRecur: moment(values["end_date"])
                            .endOf("day")
                            .toDate(),
                          display: "background",
                          backgroundColor: "#8950FC",
                        },
                      ]}
                      ref={this.guestCalendarRef}
                      plugins={[dayGridPlugin, interactionPlugin]}
                      initialView="dayGridMonth"
                      weekends={true}
                      eventContent={this.renderEventContent}
                    />
                    <div className="d-flex justify-content-between align-items-start mt-4">
                      <div>
                        <div className="d-flex align-items-center mb-2">
                          <div
                            className="mr-2"
                            style={{
                              width: "20px",
                              height: "20px",
                              backgroundColor: "#dcccff",
                              borderRadius: "4px",
                            }}
                          ></div>
                          <span>Active Event Date</span>
                        </div>

                        <div className="d-flex align-items-center">
                          <div
                            className="mr-2"
                            style={{
                              width: "20px",
                              height: "20px",
                              backgroundColor: "#fff",
                              border: "1px solid #dee2e6",
                              borderRadius: "4px",
                            }}
                          ></div>
                          <span>No Event Scheduled</span>
                        </div>
                      </div>

                      {/* Right side: info text */}
                      <div style={{ maxWidth: "45%" }}>
                        <p className="mb-2">
                          Click on the calendar to choose a date for managing
                          the guest list.
                        </p>
                      </div>
                    </div>
                  </>
                </Accordion.Collapse>
                <Accordion.Collapse
                  eventKey="timeslotCollapse"
                  in={guestSlotToggle}
                >
                  <>
                    <div className="d-flex flex-row  mt-4">
                      <div
                        onClick={() => {
                          setTimeout(() => {
                            this.guestCalendarRef.current.getApi().updateSize();
                          }, 100);

                          this.accordionOpen("guestCalendar", true);
                          this.accordionOpen("guestSlot", false);
                          this.accordionOpen("guestListTable", false);
                        }}
                      >
                        <h4
                          className="mb-2 mr-2 text-info"
                          style={{
                            cursor: "pointer",
                          }}
                        >
                          Timeslots for{" "}
                          {moment(this.state.guestListActiveDate).format(
                            "MMM DD, YYYY dddd ",
                          )}
                        </h4>
                      </div>
                      <i
                        className="fas fa-edit"
                        style={{
                          fontSize: "18px",
                          color: RESERVATION_COLOR,
                        }}
                        onClick={() => {
                          setTimeout(() => {
                            this.guestCalendarRef.current.getApi().updateSize();
                          }, 100);
                          this.accordionOpen("guestCalendar", true);
                          this.accordionOpen("guestSlot", false);
                          this.accordionOpen("guestListTable", false);
                        }}
                      />
                    </div>
                    <div className="mt-3 d-flex justify-content-center">
                      <div style={{ width: "40%" }}>
                        {this.state.values.time_slots.length === 0 && (
                          <p className="text-center">No timeslots available.</p>
                        )}

                        {this.state.values.time_slots.length > 0 && (
                          <div className="d-flex flex-column gap-3">
                            {this.state.values.time_slots.map((slot, index) => {
                              const start = moment(
                                new Date(slot.start_time),
                              ).format("hh:mm a");
                              const end = moment(
                                new Date(slot.end_time),
                              ).format("hh:mm a");
                              const isLoading = loadingSlotId === slot._id;

                              return (
                                <div
                                  key={`ticket-div-${index}`}
                                  onClick={async () => {
                                    if (isLoading) return;
                                    this.setState({ loadingSlotId: slot._id });
                                    const timeslot = slot.start_time;
                                    const guestList =
                                      await this.getComplimentaryTickets(
                                        timeslot,
                                      );
                                    const slotTickets =
                                      this.findTicketsByTimeSlot(slot._id);
                                    this.updateGuestList(
                                      guestList,
                                      slotTickets,
                                    );
                                    this.setState({
                                      selectedTimeSlot: `${start} - ${end}`,
                                      selectedSlot: timeslot,
                                      slotTickets,
                                      loadingSlotId: null,
                                    });

                                    this.toggleAccordion("guestSlot");
                                    this.toggleAccordion("guestListTable");
                                  }}
                                  className={`p-3 border rounded text-center mb-5 fw-bold bg-info text-white ${
                                    isLoading ? "disabled" : ""
                                  }`}
                                  style={{
                                    cursor: isLoading ? "wait" : "pointer",
                                    fontSize: "1.25rem",
                                  }}
                                >
                                  {start} - {end}{" "}
                                  {isLoading && (
                                    <span className="spinner spinner-white"></span>
                                  )}
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                </Accordion.Collapse>
                <Accordion.Collapse
                  eventKey="guestListTable"
                  in={guestListToggle}
                >
                  <>
                    <div className="d-flex flex-row  mt-4">
                      <div
                        onClick={() => {
                          setTimeout(() => {
                            this.guestCalendarRef.current.getApi().updateSize();
                          }, 100);
                          this.accordionOpen("guestListTable", false);
                          if (this.state.values.tickets.length > 1) {
                            this.accordionOpen("guestSlot", true);
                          } else {
                            this.accordionOpen("guestCalendar", true);
                          }
                        }}
                      >
                        <h4
                          className="mb-2 mr-2 text-info"
                          style={{
                            cursor: "pointer",
                          }}
                        >
                          Guests for{" "}
                          {moment(this.state.guestListActiveDate).format(
                            "MMM DD, YYYY dddd ",
                          )}
                          {this.state.selectedTimeSlot}
                        </h4>
                      </div>
                      <i
                        className="fas fa-edit"
                        style={{
                          fontSize: "18px",
                          color: RESERVATION_COLOR,
                        }}
                        onClick={() => {
                          setTimeout(() => {
                            this.guestCalendarRef.current.getApi().updateSize();
                          }, 100);
                          this.accordionOpen("guestListTable", false);
                          if (this.state.values.tickets.length > 1) {
                            this.accordionOpen("guestSlot", true);
                          } else {
                            this.accordionOpen("guestCalendar", true);
                          }
                        }}
                      />
                    </div>
                    <div className="table-responsive">
                      <div className="d-flex justify-content-end mb-2">
                        <Dropdown>
                          <Dropdown.Toggle
                            variant="outline-info"
                            id="guest-list-actions"
                          >
                            Table Actions
                          </Dropdown.Toggle>

                          <Dropdown.Menu style={{ minWidth: "250px" }}>
                            <Dropdown.Item
                              onClick={this.handleDownloadAttendingCSV}
                            >
                              <div className="d-flex align-items-center gap-2">
                                <i
                                  className="fas fa-download"
                                  style={{
                                    color: RESERVATION_COLOR,
                                    width: "20px",
                                  }}
                                ></i>
                                <span>Download Attending (CSV)</span>
                              </div>
                            </Dropdown.Item>

                            <Dropdown.Item onClick={this.handleDownloadPDF}>
                              <div className="d-flex align-items-center gap-2">
                                <i
                                  className="fas fa-file-pdf"
                                  style={{
                                    color: RESERVATION_COLOR,
                                    width: "20px",
                                  }}
                                ></i>
                                <span>Download Attending (PDF)</span>
                              </div>
                            </Dropdown.Item>
                            <Dropdown.Divider />
                            <Dropdown.Item
                              onClick={this.handleDownloadCSVTemplate}
                            >
                              <div className="d-flex align-items-center gap-2">
                                <i
                                  className="fas fa-download"
                                  style={{
                                    color: RESERVATION_COLOR,
                                    width: "20px",
                                  }}
                                ></i>
                                <span>Download Template</span>
                              </div>
                            </Dropdown.Item>

                            <Dropdown.Divider />

                            <Dropdown.Item
                              as="label"
                              style={{ cursor: "pointer", marginBottom: 0 }}
                            >
                              <div className="d-flex align-items-center gap-2">
                                <i
                                  className="fas fa-upload"
                                  style={{
                                    color: RESERVATION_COLOR,
                                    width: "20px",
                                  }}
                                ></i>
                                <span>Upload CSV</span>
                              </div>
                              <input
                                type="file"
                                accept=".csv"
                                hidden
                                onChange={this.handleUploadCSV}
                              />
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                      <Tabs
                        activeKey={guestListActiveTab}
                        onSelect={(k) =>
                          this.setState({ guestListActiveTab: k })
                        }
                        className="mb-3 purple-tabs"
                      >
                        <Tab eventKey="all" title={`All (${counts.all})`}></Tab>
                        <Tab
                          eventKey="attending"
                          title={`Attending (${counts.attending})`}
                        ></Tab>
                        <Tab
                          eventKey="invited"
                          title={`Invited (${counts.invited})`}
                        ></Tab>
                        <Tab
                          eventKey="rejected"
                          title={`Rejected (${counts.rejected})`}
                        ></Tab>
                      </Tabs>
                      {renderGuestListTable(displayedGuests)}
                      <div className="d-flex align-items-center justify-content-between">
                        <button
                          type="button"
                          className="btn btn-outline-secondary btn-sm"
                          onClick={() => {
                            const { slotTickets } = this.state;
                            const newGuest = {
                              firstName: "",
                              lastName: "",
                              email: "",
                              contact: "",
                              ticketType:
                                slotTickets.length === 1
                                  ? slotTickets[0].item._id
                                  : "",
                              quantity: "",
                            };
                            this.setState((prevState) => ({
                              values: {
                                ...prevState.values,
                                guestList: [
                                  ...prevState.values.guestList,
                                  newGuest,
                                ],
                              },
                            }));
                          }}
                        >
                          <i className="bi bi-plus-circle me-1"></i> Add Row
                        </button>
                        <div className="d-flex align-items-center">
                          <div className="flex-column">
                            <div className="ml-4 text-nowrap">
                              <span className="font-weight-bold">
                                Ticket Counter
                              </span>
                            </div>

                            {this.state.slotTickets.map((ticket) => {
                              if (!ticket.item) {
                                return null;
                              }
                              const used = this.state.values.guestList
                                .filter(
                                  (guest) =>
                                    guest.ticketType === ticket.item._id &&
                                    guest.invite_status !== "rejected",
                                )
                                .reduce(
                                  (acc, guest) =>
                                    acc + (parseInt(guest.quantity, 10) || 0),
                                  0,
                                );

                              const total = ticket.capacity;
                              return (
                                <div
                                  key={ticket.item._id}
                                  className="ml-4 text-nowrap"
                                >
                                  <span className="font-weight-bold">
                                    {ticket.item.name}:{" "}
                                  </span>
                                  <span>
                                    {used} / {total === 0 ? "∞" : total}
                                  </span>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                      <div className="d-flex justify-content-center mb-2">
                        <button
                          type="button"
                          onClick={() =>
                            this.processComplimentaryTickets({
                              withEmail: false,
                            })
                          }
                          className={`btn btn-light btn-elevate ${
                            isSavingForLater
                              ? "spinner spinner-right spinner-dark pr-15"
                              : ""
                          }`}
                          disabled={isEventEnded}
                        >
                          Save invites for later
                        </button>
                        <button
                          type="button"
                          disabled={
                            isEventEnded || isSavingForLater || isSendingInvites
                          }
                          onClick={this.openRsvpModal}
                          className={`ml-2 btn btn-delete rounded btn-info btn-elevate`}
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  </>
                </Accordion.Collapse>
              </Accordion>
            </div>
          </Modal.Body>
          <Modal.Footer></Modal.Footer>
        </Modal>
        <Modal
          show={this.state.showRsvpModal}
          onHide={this.handleRsvpCancel}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Set RSVP Deadline</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="rsvp-datepicker-wrapper">
              <ReactDatePicker
                selected={this.state.rsvpDeadline}
                onChange={(date) => this.setState({ rsvpDeadline: date })}
                minDate={moment(new Date()).add(1, "days").toDate()}
                maxDate={new Date(this.state.guestListActiveDate)}
                inline
              />
            </div>
            <p className="mb-2 text-muted text-right">
              Select an RSVP deadline. Reminders go out 2 days after and 1 day
              before the deadline, with auto-rejection after.
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="light"
              onClick={this.handleRsvpCancel}
              disabled={isSendingInvites}
            >
              Cancel
            </Button>
            <button
              disabled={isSendingInvites}
              style={{
                backgroundColor: RESERVATION_COLOR,
                borderColor: RESERVATION_COLOR,
              }}
              onClick={this.handleRsvpConfirm}
              className={`btn btn-delete rounded btn-info btn-elevate ${
                isSendingInvites ? "spinner spinner-right spinner-white" : ""
              }`}
            >
              {isSendingInvites ? "Confirming..." : "Send Invites"}
            </button>
          </Modal.Footer>
        </Modal>
        {showInviteLinkModal && (
          <InviteLinkManagerModal
            show={showInviteLinkModal}
            onHide={() => this.setState({ showInviteLinkModal: false })}
            store={this.state.store}
            event={this.state.event}
            api={this.api}
          />
        )}
      </Form>
    );
  }
}
